import { merge, set, forEach } from "lodash"
import crossCursor from "styles/image/icon/chart/crossCursor.png"
import crossCursor_bright from "styles/image/icon/chart/crossCursor_bright.png"
import turningPoint from "styles/image/icon/chart/turningPoint.png"
import turningPoint_bright from "styles/image/icon/chart/turningPoint_bright.png"
import closePrice from "styles/image/icon/chart/closePrice.png"
import closePrice_bright from "styles/image/icon/chart/closePrice_bright.png"
import currentValue from "styles/image/icon/chart/currentValue.png"
import currentValue_bright from "styles/image/icon/chart/currentValue_bright.png"
import loupe from "styles/image/icon/chart/loupe.png"
import loupe_bright from "styles/image/icon/chart/loupe_bright.png"
import priceVolume from "styles/image/icon/chart/priceVolume.png"
import priceVolume_bright from "styles/image/icon/chart/priceVolume_bright.png"
import cycleAna from "styles/image/icon/chart/cycleAna.png"
import cycleAna_bright from "styles/image/icon/chart/cycleAna_bright.png"
import mado from "styles/image/icon/chart/mado.png"
import mado_bright from "styles/image/icon/chart/mado_bright.png"
import readNumber from "styles/image/icon/chart/readNumber.png"
import readNumber_bright from "styles/image/icon/chart/readNumber_bright.png"
import { TERM_EXTERNAL } from "components/pages/others/external/const"

interface chartFontsObj {
  small: number
  middle: number
  large: number
  [key: string]: number
}

interface chartSessionsObj {
  [key: string]: any
}

interface chartObj {
  defaultChartTechnicalSettings: any
  defaultChartColorSettings: any
  defaultChartColorWhiteSettings: any
  ChartSessions: any
}

export const CHART_FONTS: chartFontsObj = {
  small: -2,
  middle: 0,
  large: 3,
}

export const PLOTTYPE = [
  {
    id: 0,
    displayTitle: "ローソク足",
    key: "candle",
  },
  {
    id: 1,
    displayTitle: "ラインチャート",
    key: "line",
  },
  {
    id: 2,
    displayTitle: "折れ線",
    key: "lineFill",
  },
  {
    id: 3,
    displayTitle: "ポイント&フィギュア",
    key: "PandF",
  },
]

export const TERM = [
  {
    id: 0,
    displayTitle: "1分足",
    key: "1m",
  },
  {
    id: 1,
    displayTitle: "3分足",
    key: "3m",
  },
  {
    id: 2,
    displayTitle: "5分足",
    key: "5m",
  },
  {
    id: 3,
    displayTitle: "10分足",
    key: "10m",
  },
  {
    id: 4,
    displayTitle: "15分足",
    key: "15m",
  },
  {
    id: 5,
    displayTitle: "20分足",
    key: "20m",
  },
  {
    id: 6,
    displayTitle: "30分足",
    key: "30m",
  },
  {
    id: 7,
    displayTitle: "60分足",
    key: "60m",
  },
  {
    id: 8,
    displayTitle: "日足",
    key: "1D",
  },
  {
    id: 9,
    displayTitle: "週足",
    key: "1W",
  },
  {
    id: 10,
    displayTitle: "月足",
    key: "1M",
  },
]

export const INDICATOR_CHART_TERM = [
  {
    id: 0,
    displayTitle: "ライン",
    key: "line",
  },
  {
    id: 1,
    displayTitle: "ヒストグラム",
    key: "histogram",
  },
]

export const RENDER_COUNT = {
  [TERM[0].id]: 300,
  [TERM[1].id]: 300,
  [TERM[2].id]: 120,
  [TERM[3].id]: 150,
  [TERM[4].id]: 100,
  [TERM[5].id]: 75,
  [TERM[6].id]: 150,
  [TERM[7].id]: 100,
  [TERM[8].id]: 480,
  [TERM[9].id]: 260,
  [TERM[10].id]: 120,
}

export const RENDER_COUNT_EXTERNAL = {
  [TERM_EXTERNAL[0].id]: 200,
  [TERM_EXTERNAL[1].id]: 50,
  [TERM_EXTERNAL[2].id]: 100,
  [TERM_EXTERNAL[3].id]: 40,
  [TERM_EXTERNAL[4].id]: 80,
  [TERM_EXTERNAL[5].id]: 40,
}

// ツール群
export const TOOLS = [
  {
    id: 0,
    displayTitle: "クロスカーソル",
    icon: crossCursor_bright,
    icon_dark: crossCursor,
    key: "crossCursor",
  },
  {
    id: 1,
    displayTitle: "転換点",
    icon: turningPoint_bright,
    icon_dark: turningPoint,
    key: "turningPoint",
  },
  {
    id: 2,
    displayTitle: "前日終値ライン",
    icon: closePrice_bright,
    icon_dark: closePrice,
    key: "closePrice",
  },
  {
    id: 3,
    displayTitle: "現値ラベル",
    icon: currentValue_bright,
    icon_dark: currentValue,
    key: "currentValue",
  },
  {
    id: 4,
    displayTitle: "ルーペ",
    icon: loupe_bright,
    icon_dark: loupe,
    key: "loupe",
  },
  {
    id: 5,
    displayTitle: "価格帯別出来高",
    icon: priceVolume_bright,
    icon_dark: priceVolume,
    key: "priceVolume",
  },
  {
    id: 6,
    displayTitle: "日柄分析",
    icon: cycleAna_bright,
    icon_dark: cycleAna,
    key: "cycleAna",
  },
  {
    id: 7,
    displayTitle: "窓",
    icon: mado_bright,
    icon_dark: mado,
    key: "mado",
  },
  {
    id: 8,
    displayTitle: "数値読取",
    icon: readNumber_bright,
    icon_dark: readNumber,
    key: "readNumber",
  },
]
// 図形群
export const FIGURE_TYPE_OPTIONS = [
  {
    id: 0,
    displayTitle: "高値・安値",
    key: "hight-low",
  },
  {
    id: 1,
    displayTitle: "始値・終値",
    key: "open-close",
  },
]
export const FIGURE_GANN_FAN_OPTIONS = [
  ...FIGURE_TYPE_OPTIONS,
  {
    id: 2,
    displayTitle: "0.5％",
    key: "0.5％",
  },
  {
    id: 3,
    displayTitle: "0.333％",
    key: "0.333％",
  },
  {
    id: 4,
    displayTitle: "0.25％",
    key: "0.25％",
  },
  {
    id: 5,
    displayTitle: "0.125％",
    key: "0.125％",
  },
]
export const FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS = [
  ...FIGURE_TYPE_OPTIONS,
  {
    id: 2,
    displayTitle: "261.8％",
    key: "261.8％",
  },
  {
    id: 3,
    displayTitle: "161.8％",
    key: "161.8％",
  },
  {
    id: 4,
    displayTitle: "138.2％",
    key: "138.2％",
  },
  {
    id: 5,
    displayTitle: "100.0％",
    key: "100.0％",
  },
  {
    id: 6,
    displayTitle: "76.4％",
    key: "76.4％",
  },
  {
    id: 7,
    displayTitle: "61.8％",
    key: "61.8％",
  },
  {
    id: 8,
    displayTitle: "50.0％",
    key: "50.0％",
  },
  {
    id: 9,
    displayTitle: "38.2％",
    key: "38.2％",
  },
  {
    id: 10,
    displayTitle: "23.6％",
    key: "23.6％",
  },
  {
    id: 11,
    displayTitle: "14.6％",
    key: "14.6％",
  },
  {
    id: 12,
    displayTitle: "0.0％",
    key: "0.0％",
  },
  {
    id: 13,
    displayTitle: "-23.6％",
    key: "-23.6％",
  },
  {
    id: 14,
    displayTitle: "-38.2％",
    key: "-38.2％",
  },
  {
    id: 15,
    displayTitle: "-50.0％",
    key: "-50.0％",
  },
]
export const FIGURE_FIBO_TIMEZONE_OPTIONS = [
  ...FIGURE_TYPE_OPTIONS,
  {
    id: 2,
    displayTitle: "1",
    key: "1",
  },
  {
    id: 3,
    displayTitle: "2",
    key: "2",
  },
  {
    id: 4,
    displayTitle: "3",
    key: "3",
  },
  {
    id: 5,
    displayTitle: "4",
    key: "4",
  },
  {
    id: 6,
    displayTitle: "6",
    key: "6",
  },
  {
    id: 7,
    displayTitle: "8",
    key: "8",
  },
  {
    id: 8,
    displayTitle: "13",
    key: "13",
  },
  {
    id: 9,
    displayTitle: "21",
    key: "21",
  },
  {
    id: 10,
    displayTitle: "34",
    key: "34",
  },
]
// 図形コマンド
export const FIGURE_COMMAND = [
  {
    id: 0,
    displayTitle: "図形削除",
    key: "remove",
    icon: "backspace",
  },
  {
    id: 1,
    displayTitle: "図形複写",
    key: "copy",
    icon: "filter_none",
  },
  {
    id: 2,
    displayTitle: "図形移動",
    key: "move",
    icon: "swap_horiz",
  },
  {
    id: 3,
    displayTitle: "全削除",
    key: "allremove",
    icon: "delete",
  },
]
// ライン
export const FIGURE = [
  {
    id: 0,
    displayTitle: "トレンドライン",
    key: "trendLine",
    type: [
      {
        id: 0,
        displayTitle: "トレンドライン",
        icon: "edit",
        key: "line",
        options: FIGURE_TYPE_OPTIONS,
      },
      {
        id: 1,
        displayTitle: "無限線",
        icon: "remove",
        iconTransform: "rotate135",
        key: "infiniteline",
        options: FIGURE_TYPE_OPTIONS,
      },
      {
        id: 2,
        displayTitle: "水平",
        icon: "remove",
        key: "horizontal",
        options: FIGURE_TYPE_OPTIONS,
      },
    ],
  },
  {
    id: 1,
    displayTitle: "ギャン",
    key: "Gann",
    type: [
      {
        id: 0,
        displayTitle: "ギャン・ファン",
        icon: "share",
        key: "fan",
        options: FIGURE_GANN_FAN_OPTIONS,
      },
      {
        id: 1,
        displayTitle: "ギャン・グリッド",
        icon: "grid_on",
        key: "grid",
        options: FIGURE_TYPE_OPTIONS,
      },
    ],
  },
  {
    id: 2,
    displayTitle: "フィボナッチ",
    key: "Fibonacci",
    type: [
      {
        id: 0,
        displayTitle: "フィボナッチ・リトレースメント",
        icon: "format_align_justify",
        key: "retracement",
        options: FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS,
      },
      {
        id: 1,
        displayTitle: "フィボナッチ・エクスパンション",
        icon: "done",
        key: "expansion",
        options: FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS,
      },
      {
        id: 2,
        displayTitle: "フィボナッチ・タイムゾーン",
        icon: "reorder",
        iconTransform: "rotate90",
        key: "timezone",
        options: FIGURE_FIBO_TIMEZONE_OPTIONS,
      },
      {
        id: 3,
        displayTitle: "フィボナッチ・アーク",
        icon: "looks",
        key: "arc",
        options: FIGURE_TYPE_OPTIONS,
      },
      {
        id: 4,
        displayTitle: "フィボナッチ・ファン",
        icon: "send",
        iconTransform: "rotate180",
        key: "fibofan",
        options: FIGURE_TYPE_OPTIONS,
      },
    ],
  },
]

export const FIGURE_TYPE = [
  {
    id: 0,
    displayTitle: "トレンドライン",
    icon: "edit",
    key: "line",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[0].id,
  },
  {
    id: 1,
    displayTitle: "無限線",
    icon: "remove",
    iconTransform: "rotate135",
    key: "infiniteline",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[0].id,
  },
  {
    id: 2,
    displayTitle: "水平",
    icon: "remove",
    key: "horizontal",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[0].id,
  },
  {
    id: 0,
    displayTitle: "ギャン・ファン",
    icon: "share",
    key: "fan",
    options: FIGURE_GANN_FAN_OPTIONS,
    parentId: FIGURE[1].id,
  },
  {
    id: 1,
    displayTitle: "ギャン・グリッド",
    icon: "grid_on",
    key: "grid",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[1].id,
  },
  {
    id: 0,
    displayTitle: "フィボナッチ・リトレースメント",
    icon: "format_align_justify",
    key: "retracement",
    options: FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS,
    parentId: FIGURE[2].id,
  },
  {
    id: 1,
    displayTitle: "フィボナッチ・エクスパンション",
    icon: "playlist_add_check",
    key: "expansion",
    options: FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS,
    parentId: FIGURE[2].id,
  },
  {
    id: 2,
    displayTitle: "フィボナッチ・タイムゾーン",
    icon: "reorder",
    iconTransform: "rotate90",
    key: "timezone",
    options: FIGURE_FIBO_TIMEZONE_OPTIONS,
    parentId: FIGURE[2].id,
  },
  {
    id: 3,
    displayTitle: "フィボナッチ・アーク",
    icon: "looks",
    key: "arc",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[2].id,
  },
  {
    id: 4,
    displayTitle: "フィボナッチ・ファン",
    icon: "send",
    iconTransform: "rotate180",
    key: "fibofan",
    options: FIGURE_TYPE_OPTIONS,
    parentId: FIGURE[2].id,
  },
]

export const FIGURE_OPTIONS_DEFAULT_SETTINGS = {
  line: { figure: FIGURE[0].id, option: [0, 1] },
  infiniteline: { figure: FIGURE[0].id, option: [0, 1] },
  horizontal: { figure: FIGURE[0].id, option: [0, 1] },
  fan: {
    figure: FIGURE[1].id,
    option: [0, 1, 2, 3, 4, 5],
  },
  grid: {
    figure: FIGURE[1].id,
    option: [0, 1],
  },
  retracement: {
    figure: FIGURE[2].id,
    option: [0, 1, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  expansion: {
    figure: FIGURE[2].id,
    option: [0, 1, 5, 6, 7, 8, 9, 10, 12],
  },
  timezone: {
    figure: FIGURE[2].id,
    option: [0, 1, 2, 3, 4, 5, 6, 7],
  },
  arc: {
    figure: FIGURE[2].id,
    option: [0, 1],
  },
  fibofan: {
    figure: FIGURE[2].id,
    option: [0, 1],
  },
}

// addon Chart
export const AVERAGEN_OPTIONS = [
  {
    id: 0,
    displayTitle: "移動平均1",
    key: "AverageN_1",
  },
  {
    id: 1,
    displayTitle: "移動平均2",
    key: "AverageN_2",
  },
  {
    id: 2,
    displayTitle: "移動平均3",
    key: "AverageN_3",
  },
  {
    id: 3,
    displayTitle: "移動平均4",
    key: "AverageN_4",
  },
  {
    id: 4,
    displayTitle: "移動平均5",
    key: "AverageN_5",
  },
]
export const KSBOLINGER_OPTIONS = [
  {
    id: 0,
    displayTitle: "移動平均",
    key: "BolingerMa",
  },
  {
    id: 1,
    displayTitle: "標準偏差1",
    key: "Bolinger_1",
  },
  {
    id: 2,
    displayTitle: "標準偏差2",
    key: "Bolinger_2",
  },
  {
    id: 3,
    displayTitle: "標準偏差3",
    key: "Bolinger_3",
  },
]
export const ENVELOPE_OPTIONS = [
  {
    id: 0,
    displayTitle: "移動平均",
    key: "Envelope_Ma",
  },
  {
    id: 1,
    displayTitle: "乖離率1",
    key: "Envelope_1",
  },
  {
    id: 2,
    displayTitle: "乖離率2",
    key: "Envelope_2",
  },
  {
    id: 3,
    displayTitle: "乖離率3",
    key: "Envelope_3",
  },
]
export const ICHIMOKU_OPTIONS = [
  {
    id: 0,
    displayTitle: "転換線期間",
    key: "Tenkan_Value",
  },
  {
    id: 1,
    displayTitle: "基準線期間",
    key: "Kijyun_Value",
  },
  {
    id: 2,
    displayTitle: "遅行ライン",
    key: "DelayLine",
  },
  {
    id: 3,
    displayTitle: "スパン期間",
    key: "Span_Value",
  },
  {
    id: 4,
    displayTitle: "先行スパン1",
    key: "PrecedLine1",
  },
  {
    id: 5,
    displayTitle: "先行スパン2",
    key: "PrecedLine2",
  },
  {
    id: 6,
    displayTitle: "雲1",
    key: "Kumo",
  },
  {
    id: 7,
    displayTitle: "雲2",
    key: "Kumo2",
  },
]
export const PARABOLIC_OPTIONS = [
  {
    id: 0,
    displayTitle: "AF初期値",
    key: "Parabolic_AF",
  },
  {
    id: 1,
    displayTitle: "最大値",
    key: "Parabolic_Max",
  },
  {
    id: 2,
    displayTitle: "ステップ",
    key: "Parabolic_Step",
  },
  {
    id: 3,
    displayTitle: "上昇",
    key: "Parabolic_Up",
  },
  {
    id: 4,
    displayTitle: "下降",
    key: "Parabolic_Down",
  },
]
export const HLBAND_OPTIONS = [
  {
    id: 0,
    displayTitle: "中心線",
    key: "HLBand_CenterLine",
  },
  {
    id: 1,
    displayTitle: "高値算出期間",
    key: "HLBand_highPeriod",
  },
  {
    id: 2,
    displayTitle: "安値算出期間",
    key: "HLBand_lowPeriod",
  },
]
export const ATRCHANNEL_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "ATRChannel_Lma",
  },
  {
    id: 1,
    displayTitle: "ATR",
    key: "ATRChannel_Atr",
  },
  {
    id: 2,
    displayTitle: "チャネル1",
    key: "ATRChannel_1",
  },
  {
    id: 3,
    displayTitle: "チャネル2",
    key: "ATRChannel_2",
  },
  {
    id: 4,
    displayTitle: "チャネル3",
    key: "ATRChannel_3",
  },
]
export const EMA_OPTIONS = [
  {
    id: 0,
    displayTitle: "EMA1",
    key: "EMA_1",
  },
  {
    id: 1,
    displayTitle: "EMA2",
    key: "EMA_2",
  },
  {
    id: 2,
    displayTitle: "EMA3",
    key: "EMA_3",
  },
]
export const KAIKI_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "Kikan",
  },
  {
    id: 1,
    displayTitle: "標準偏差1",
    key: "Kaiki_1",
  },
  {
    id: 2,
    displayTitle: "標準偏差2",
    key: "Kaiki_2",
  },
  {
    id: 3,
    displayTitle: "標準偏差3",
    key: "Kaiki_3",
  },
]
export const VWAP_OPIONS = [
  {
    id: 0,
    displayTitle: "VWAP",
    key: "VWAP",
  },
]
export const ADDON_CHART = [
  {
    id: 0,
    displayTitle: "移動平均",
    key: "AverageN",
    options: AVERAGEN_OPTIONS,
  },
  {
    id: 1,
    displayTitle: "ボリンジャーバンド",
    key: "KSBolinger",
    options: KSBOLINGER_OPTIONS,
  },
  {
    id: 2,
    displayTitle: "移動平均エンベロープ",
    key: "Envelope",
    options: ENVELOPE_OPTIONS,
  },
  {
    id: 3,
    displayTitle: "一目均衡表",
    key: "Ichimoku",
    options: ICHIMOKU_OPTIONS,
  },
  {
    id: 4,
    displayTitle: "パラボリック",
    key: "ParabolicDiv",
    options: PARABOLIC_OPTIONS,
  },
  {
    id: 5,
    displayTitle: "HLバンド",
    key: "HLBand",
    options: HLBAND_OPTIONS,
  },
  {
    id: 6,
    displayTitle: "ATRチャネル",
    key: "ATRChannel",
    options: ATRCHANNEL_OPTIONS,
  },
  {
    id: 7,
    displayTitle: "指数平滑移動平均線",
    key: "EMA",
    options: EMA_OPTIONS,
  },
  {
    id: 8,
    displayTitle: "回帰トレンド",
    key: "Kaiki",
    options: KAIKI_OPTIONS,
  },
  {
    id: 9,
    displayTitle: "VWAP(分足のみ)",
    key: "Vwap",
    options: VWAP_OPIONS,
  },
]

export class ADDON_CHART_DEFAULT_OPTIONS {
  defaultOptions: object
  constructor() {
    this.defaultOptions = {
      [ADDON_CHART[0].key]: [
        ADDON_CHART[0].options[0],
        ADDON_CHART[0].options[1],
      ],
      [ADDON_CHART[1].key]: [
        ADDON_CHART[1].options[0],
        ADDON_CHART[1].options[1],
        ADDON_CHART[1].options[2],
      ],
      [ADDON_CHART[2].key]: [
        ADDON_CHART[2].options[0],
        ADDON_CHART[2].options[1],
        ADDON_CHART[2].options[2],
      ],
      [ADDON_CHART[6].key]: [
        ADDON_CHART[6].options[0],
        ADDON_CHART[6].options[1],
        ADDON_CHART[6].options[2],
      ],
      [ADDON_CHART[7].key]: [
        ADDON_CHART[7].options[0],
        ADDON_CHART[7].options[1],
      ],
      [ADDON_CHART[8].key]: [
        ADDON_CHART[8].options[0],
        ADDON_CHART[8].options[1],
        ADDON_CHART[8].options[2],
      ],
    }
  }
}

// subChart
export const RSI_OPTIONS = [
  {
    id: 0,
    displayTitle: "RSI",
    key: "RSI_Period",
  },
  {
    id: 1,
    displayTitle: "ローライン",
    key: "RSI_Scale1",
  },
  {
    id: 2,
    displayTitle: "ミドルライン",
    key: "RSI_Scale3",
  },
  {
    id: 3,
    displayTitle: "ハイライン",
    key: "RSI_Scale2",
  },
]
export const STOCAST_KD_OPTIONS = [
  {
    id: 0,
    displayTitle: "%K",
    key: "Stocast_K",
  },
  {
    id: 1,
    displayTitle: "%D",
    key: "Stocast_D",
  },
  {
    id: 2,
    displayTitle: "ローライン",
    key: "Stocast_Scale1",
  },
  {
    id: 3,
    displayTitle: "ミドルライン",
    key: "Stocast_Scale3",
  },
  {
    id: 4,
    displayTitle: "ハイライン",
    key: "Stocast_Scale2",
  },
]
export const STOCAST_DS_OPTIONS = [
  {
    id: 0,
    displayTitle: "%K",
    key: "Stocast_DS_K",
  },
  {
    id: 1,
    displayTitle: "%D",
    key: "Stocast_DS_D",
  },
  {
    id: 2,
    displayTitle: "S%D Slow",
    key: "Stocast_DS_S",
  },
  {
    id: 3,
    displayTitle: "ローライン",
    key: "Stocast_Scale1",
  },
  {
    id: 4,
    displayTitle: "ミドルライン",
    key: "Stocast_Scale3",
  },
  {
    id: 5,
    displayTitle: "ハイライン",
    key: "Stocast_Scale2",
  },
]
export const PERCENT_R_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "PercentR_Period",
  },
]
export const MACD_OPTIONS = [
  {
    id: 0,
    displayTitle: "短期",
    key: "MACD_S",
  },
  {
    id: 1,
    displayTitle: "長期",
    key: "MACD_L",
  },
  {
    id: 2,
    displayTitle: "シグナル",
    key: "MACD_signal",
  },
  {
    id: 3,
    displayTitle: "OSCI",
    key: "MACD_Osci",
  },
]
export const CCI_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "CCI_Period",
  },
]
export const PSYCOLOGIC_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "PsyCologic_Period",
  },
  {
    id: 1,
    displayTitle: "ローライン",
    key: "PsyCologic_Scale1",
  },
  {
    id: 2,
    displayTitle: "ミドルライン",
    key: "PsyCologic_Scale3",
  },
  {
    id: 3,
    displayTitle: "ハイライン",
    key: "PsyCologic_Scale2",
  },
]
export const ATR_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "ATR_Period",
  },
]
export const AROON_INDI_OPTIONS = [
  {
    id: 0,
    displayTitle: "UP期間",
    key: "AroonIndi_UpPeriod",
  },
  {
    id: 1,
    displayTitle: "DOWN期間",
    key: "AroonIndi_DownPeriod",
  },
]
export const AROON_OSCI_OPTIONS = [
  {
    id: 0,
    displayTitle: "UP期間",
    key: "AroonOsci_UpPeriod",
  },
  {
    id: 1,
    displayTitle: "DOWN期間",
    key: "AroonOsci_DownPeriod",
  },
  {
    id: 2,
    displayTitle: "AroonOsci",
    key: "AroonOsci",
  },
]
export const KAIRI_OPTIONS = [
  {
    id: 0,
    displayTitle: "乖離率1",
    key: "Kairi3_1",
  },
  {
    id: 1,
    displayTitle: "乖離率2",
    key: "Kairi3_2",
  },
  {
    id: 2,
    displayTitle: "乖離率3",
    key: "Kairi3_3",
  },
  {
    id: 3,
    displayTitle: "ローライン",
    key: "Kairi3_Scale1",
  },
  {
    id: 4,
    displayTitle: "ミドルライン",
    key: "Kairi3_Scale3",
  },
  {
    id: 5,
    displayTitle: "ハイライン",
    key: "Kairi3_Scale2",
  },
]
export const VOLUME_OPTIONS = [
  {
    id: 0,
    displayTitle: "売買高",
    key: "Volume",
  },
  {
    id: 1,
    displayTitle: "移動平均1",
    key: "Volume_Short",
  },
  {
    id: 2,
    displayTitle: "移動平均2",
    key: "Volume_Middle",
  },
  {
    id: 3,
    displayTitle: "移動平均3",
    key: "Volume_Long",
  },
]
export const RCI_OPTIONS = [
  {
    id: 0,
    displayTitle: "RCI1",
    key: "RCI_Period1",
  },
  {
    id: 1,
    displayTitle: "RCI2",
    key: "RCI_Period2",
  },
  {
    id: 2,
    displayTitle: "RCI3",
    key: "RCI_Period3",
  },
  {
    id: 3,
    displayTitle: "ローライン",
    key: "RCI_Scale1",
  },
  {
    id: 4,
    displayTitle: "ミドルライン",
    key: "RCI_Scale3",
  },
  {
    id: 5,
    displayTitle: "ハイライン",
    key: "RCI_Scale2",
  },
]
export const ROC_OPTIONS = [
  {
    id: 0,
    displayTitle: "ROC1",
    key: "ROC_Period1",
  },
  {
    id: 1,
    displayTitle: "ROC2",
    key: "ROC_Period2",
  },
]
export const MOMENTUM_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "Momentum_Period1",
  },
  {
    id: 1,
    displayTitle: "移動平均期間",
    key: "Momentum_SKikan",
  },
]
export const DMI_OPTIONS = [
  {
    id: 0,
    displayTitle: "DMI",
    key: "DMI_dmi",
  },
  {
    id: 1,
    displayTitle: "修正平均",
    key: "ADXModifier",
  },
  {
    id: 2,
    displayTitle: "+DI",
    key: "+DI",
  },
  {
    id: 3,
    displayTitle: "-DI",
    key: "-DI",
  },
  {
    id: 4,
    displayTitle: "ADX1",
    key: "DMI_Adx1",
  },
  {
    id: 5,
    displayTitle: "ADXR1",
    key: "DMI_Adxr1",
  },
  {
    id: 6,
    displayTitle: "ADX2",
    key: "DMI_Adx2",
  },
  {
    id: 7,
    displayTitle: "ADXR2",
    key: "DMI_Adxr2",
  },
]
export const SHINYOUZAN_OPTIONS = [
  {
    id: 0,
    displayTitle: "買残",
    key: "MarginBuying",
  },
  {
    id: 1,
    displayTitle: "売残",
    key: "MarginSelling",
  },
]
export const STANDARD_DEVIATION_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "STANDARD_DEVIATION_Period",
  },
]
export const HINOHARA_Ratio_OPTIONS = [
  {
    id: 0,
    displayTitle: "期間",
    key: "HinoharaRatio_Period",
  },
  {
    id: 1,
    displayTitle: "Aレシオ",
    key: "HinoharaRatio_RatioA",
  },
  {
    id: 2,
    displayTitle: "Bレシオ",
    key: "HinoharaRatio_RatioB",
  },
]
export const SPREAD_OPTIONS = [
  {
    id: 0,
    displayTitle: "対比銘柄1",
    key: "Spread1",
  },
  {
    id: 1,
    displayTitle: "対比銘柄2",
    key: "Spread2",
  },
]
export const SUB_CHART = [
  {
    id: 0,
    displayTitle: "RSI",
    key: "RSI",
    options: RSI_OPTIONS,
  },
  {
    id: 1,
    displayTitle: "ストキャスティクス",
    key: "StocastKD",
    options: STOCAST_KD_OPTIONS,
  },
  {
    id: 2,
    displayTitle: "スローストキャスティクス",
    key: "StocastDS",
    options: STOCAST_DS_OPTIONS,
  },
  {
    id: 3,
    displayTitle: "%R",
    key: "PercentR",
    options: PERCENT_R_OPTIONS,
  },
  {
    id: 4,
    displayTitle: "MACD",
    key: "MACD",
    options: MACD_OPTIONS,
  },
  {
    id: 5,
    displayTitle: "CCI",
    key: "CCI",
    options: CCI_OPTIONS,
  },
  {
    id: 6,
    displayTitle: "サイコロジカル",
    key: "PsyCologic",
    options: PSYCOLOGIC_OPTIONS,
  },
  {
    id: 7,
    displayTitle: "ATR",
    key: "ATR",
    options: ATR_OPTIONS,
  },
  {
    id: 8,
    displayTitle: "アルーン・インジケーター",
    key: "AroonIndi",
    options: AROON_INDI_OPTIONS,
  },
  {
    id: 9,
    displayTitle: "アルーン・オシレーター",
    key: "AroonOsci",
    options: AROON_OSCI_OPTIONS,
  },
  {
    id: 10,
    displayTitle: "移動平均乖離率",
    key: "Kairi3",
    options: KAIRI_OPTIONS,
  },
  {
    id: 11,
    displayTitle: "売買高",
    key: "Volume",
    options: VOLUME_OPTIONS,
  },
  {
    id: 12,
    displayTitle: "RCI",
    key: "RCI3",
    options: RCI_OPTIONS,
  },
  {
    id: 13,
    displayTitle: "ROC",
    key: "ROC2",
    options: ROC_OPTIONS,
  },
  {
    id: 14,
    displayTitle: "モメンタム",
    key: "MomentumS",
    options: MOMENTUM_OPTIONS,
  },
  {
    id: 15,
    displayTitle: "DMI",
    key: "DMImod",
    options: DMI_OPTIONS,
  },
  {
    id: 16,
    displayTitle: "信用残(週足のみ)",
    key: "SinyouZan",
    options: SHINYOUZAN_OPTIONS,
  },
  {
    id: 17,
    displayTitle: "標準偏差",
    key: "StandardDeviation",
    options: STANDARD_DEVIATION_OPTIONS,
  },
  {
    id: 18,
    displayTitle: "強弱レシオ",
    key: "HinoharaRatio",
    options: HINOHARA_Ratio_OPTIONS,
  },
  {
    id: 19,
    displayTitle: "スプレッド(比較チャートのみ)",
    key: "Spread",
    options: SPREAD_OPTIONS,
  },
]

export class SUB_CHART_DEFAULT_OPTIONS {
  defaultOptions: object
  constructor() {
    this.defaultOptions = {
      [SUB_CHART[0].key]: [SUB_CHART[0].options[1], SUB_CHART[0].options[3]],
      [SUB_CHART[1].key]: [
        SUB_CHART[1].options[0],
        SUB_CHART[1].options[1],
        SUB_CHART[1].options[2],
        SUB_CHART[1].options[4],
      ],
      [SUB_CHART[2].key]: [
        SUB_CHART[2].options[1],
        SUB_CHART[2].options[2],
        SUB_CHART[2].options[3],
        SUB_CHART[2].options[5],
      ],
      [SUB_CHART[4].key]: [
        SUB_CHART[4].options[0],
        SUB_CHART[4].options[2],
        SUB_CHART[4].options[3],
      ],
      [SUB_CHART[6].key]: [SUB_CHART[6].options[1], SUB_CHART[6].options[3]],
      [SUB_CHART[10].key]: [
        SUB_CHART[10].options[0],
        SUB_CHART[10].options[1],
        SUB_CHART[10].options[3],
        SUB_CHART[10].options[5],
      ],
      [SUB_CHART[11].key]: [SUB_CHART[11].options[1], SUB_CHART[11].options[2]],
      [SUB_CHART[12].key]: [
        SUB_CHART[12].options[0],
        SUB_CHART[12].options[1],
        SUB_CHART[12].options[2],
        SUB_CHART[12].options[3],
        SUB_CHART[12].options[5],
      ],
      [SUB_CHART[13].key]: [SUB_CHART[13].options[0], SUB_CHART[13].options[1]],
      [SUB_CHART[14].key]: [SUB_CHART[14].options[1]],
      [SUB_CHART[14].key]: [SUB_CHART[14].options[1]],
      [SUB_CHART[15].key]: [
        SUB_CHART[15].options[2],
        SUB_CHART[15].options[3],
        SUB_CHART[15].options[4],
        SUB_CHART[15].options[5],
      ],
      [SUB_CHART[16].key]: [SUB_CHART[16].options[0], SUB_CHART[16].options[1]],
      [SUB_CHART[18].key]: [SUB_CHART[18].options[1], SUB_CHART[18].options[2]],
    }
  }
}

// font
export const FONT = [
  {
    id: 0,
    displayTitle: "細",
    key: "1",
  },
  {
    id: 1,
    displayTitle: "中",
    key: "3",
  },
  {
    id: 2,
    displayTitle: "太",
    key: "5",
  },
]
export const FontName =
  '"Roboto", "Noto Sans JP", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", sans-serif;'

export const CHART_ASHI_NAN = 0

interface optionsObj {
  [key: string]: Array<string> | string
}

export const CONVERT_OPTIONS: optionsObj = {
  AverageN_1: ["Ma1"],
  AverageN_2: ["Ma2"],
  AverageN_3: ["Ma3"],
  AverageN_4: ["Ma4"],
  AverageN_5: ["Ma5"],
  BolingerMa: ["Sma"],
  Bolinger_1: ["BolSigma1", "BolSigma1m"],
  Bolinger_2: ["BolSigma2", "BolSigma2m"],
  Bolinger_3: ["BolSigma3", "BolSigma3m"],
  EMA_1: ["Short"],
  EMA_2: ["Middle"],
  EMA_3: ["Long"],
  Envelope_Ma: ["Sma"],
  Envelope_1: ["EnvSigma1", "EnvSigma1m"],
  Envelope_2: ["EnvSigma2", "EnvSigma2m"],
  Envelope_3: ["EnvSigma3", "EnvSigma3m"],
  Tenkan_Value: ["TenkanLine"],
  Kijyun_Value: ["KijunLine"],
  DelayLine: ["DelayLine"],
  PrecedLine1: ["PrecedLine1"],
  PrecedLine2: ["PrecedLine2"],
  Kumo: ["Kumo"],
  Kumo2: ["Kumo2"],
  Parabolic_Up: ["CircleBuy"],
  Parabolic_Down: ["CircleSell"],
  HLBand_CenterLine: ["Center"],
  HLBand_highPeriod: ["HLine"],
  HLBand_lowPeriod: ["LLine"],
  ATRChannel_Lma: ["Lma"],
  ATRChannel_1: ["ATRChannelSigma1", "ATRChannelSigma1m"],
  ATRChannel_2: ["ATRChannelSigma2", "ATRChannelSigma2m"],
  ATRChannel_3: ["ATRChannelSigma3", "ATRChannelSigma3m"],
  Kikan: ["Kaiki"],
  Kaiki_1: ["KaikiSigma1", "KaikiSigma1m"],
  Kaiki_2: ["KaikiSigma2", "KaikiSigma2m"],
  Kaiki_3: ["KaikiSigma3", "KaikiSigma3m"],
  VWAP: ["Vwap"],
  RSI_Period: ["RSI"],
  PercentR_Period: ["PercentR"],
  Stocast_K: ["PercentK"],
  Stocast_D: ["PercentD"],
  Stocast_DS_D: ["PercentD"],
  Stocast_DS_S: ["SPercentD"],
  MACD_S: ["MACD"],
  MACD_signal: ["Signal"],
  MACD_Osci: ["OSCI"],
  RCI_Period1: ["RCI1"],
  RCI_Period2: ["RCI2"],
  RCI_Period3: ["RCI3"],
  CCI_Period: ["CCI"],
  PsyCologic_Period: ["PsyCologic"],
  ROC_Period1: ["ROC1"],
  ROC_Period2: ["ROC2"],
  ATR_Period: ["ATR"],
  Momentum_Period1: ["Momentum"],
  Momentum_SKikan: ["Signal"],
  "+DI": ["+DI"],
  "-DI": ["-DI"],
  DMI_Adx1: ["ADX1"],
  DMI_Adx2: ["ADX2"],
  DMI_Adxr1: ["ADXR1"],
  DMI_Adxr2: ["ADXR2"],
  AroonIndi_UpPeriod: ["AroonUp"],
  AroonIndi_DownPeriod: ["AroonDown"],
  AroonOsci: ["AroonOsci"],
  Kairi3_1: ["Short"],
  Kairi3_2: ["Middle"],
  Kairi3_3: ["Long"],
  MarginBuying: ["MarginBuying"],
  MarginSelling: ["MarginSelling"],
  STANDARD_DEVIATION_Period: ["StandardDeviation"],
  HinoharaRatio_RatioA: ["RatioA"],
  HinoharaRatio_RatioB: ["RatioB"],
  Spread1: ["Spread1"],
  Spread2: ["Spread2"],
  Volume_Short: ["Short"],
  Volume: ["Volume"],
  Volume_Middle: ["Middle"],
  Volume_Long: ["Long"],
  PriceVolume: ["PriceVolume"],
  PvMaxVolume: ["PvMaxVolume"],
  PvMaxNum: ["PvMaxNum"],
  PvMaxNumBack: ["PvMaxNumBack"],
  CycleHigh: ["CycleHigh"],
  CycleLow: ["CycleLow"],
  CycleHighFont: ["CycleHighFont"],
  CycleLowFont: ["CycleLowFont"],
  Tenkan_Label: ["Tenkan_Label"],
  Tenkan_Fill: ["Tenkan_Fill"],
  Line_Line: ["Line_Line"],
  LineFill_Line: ["LineFill_Line"],
  LineFill_Top: ["LineFill_Top"],
  LineFill_Bottom: ["LineFill_Bottom"],
  Scroll_Back: ["Scroll_Back"],
  Scroll_ViewRange: ["Scroll_ViewRange"],
  Scroll_ViewRangeLight: ["Scroll_ViewRangeLight"],
  Scroll_Data: ["Scroll_Data"],
  Scroll_DataLine: ["Scroll_DataLine"],
  Scroll_HandleMark: ["Scroll_HandleMark"],
  Scroll_HandleBorder: ["Scroll_HandleBorder"],
  Candle_UpArea: ["Candle_UpArea"],
  Candle_UpFrame: ["Candle_UpFrame"],
  Candle_DownArea: ["Candle_DownArea"],
  Candle_DownFrame: ["Candle_DownFrame"],
  ChartFill: ["ChartFill"],
  AreaFill: ["AreaFill"],
  AreaDraw: ["AreaDraw"],
  Grid: ["Grid"],
  SubChartLabel: ["SubChartLabel"],
  Label: ["Label"],
  CK_ScaleLine: ["CK_ScaleLine"],
  CrossCursolLine: ["CrossCursolLine"],
  CrossCursolLblDraw: ["CrossCursolLblDraw"],
  CrossCursolLblFill: ["CrossCursolLblFill"],
  subBrand1: ["subBrand1"],
  subBrand2: ["subBrand2"],
  TrendLine: ["TrendLine"],
  CK_HANDLINGDRAINGITEM: ["CK_HANDLINGDRAINGITEM"],
  CK_LOUPEFRAME: ["CK_LOUPEFRAME"],
  CK_INNERAREAHANDLE: ["CK_INNERAREAHANDLE"],
  PAndF_Down: ["PAndF_Down"],
  PAndF_Up: ["PAndF_Up"],
  FiboReTracement: ["FiboReTracement"],
  FiboExpansion: ["FiboExpansion"],
  FiboTimeZone: ["FiboTimeZone"],
  FiboFan: ["FiboFan"],
  FiboArc: ["FiboArc"],
  GannFan: ["GannFan"],
  GannGrid: ["GannGrid"],
  MadoBackGroundUp: ["MadoBackGroundUp"],
  MadoBackGroundDown: ["MadoBackGroundDown"],
  MadoValue: ["MadoValue"],
}

export const SPINNER_NAME = {
  //全般
  search_modal_kabu: 1, //検索モーダル・株タブ
  search_modal_sakimono: 2,
  search_modal_option: 3,

  //注文
  order_stocks_custody: 4, //預り証券一覧
  order_stocks_buy: 5, //買付注文
  order_stocks_sell: 6, //売付注文
  order_stocks_history: 7, //注文照会・訂正取消
  order_trust_list: 8, //信用建局一覧
  order_trust_buy: 9, //新規建注文
  order_trust_repayment: 10, //返済注文
  order_trust_swap_order: 11, //品受・品渡注文/照会-注文
  order_trust_swap_cancel: 12, //品受・品渡注文/照会-照会
  order_trust_history: 13, //注文照会・訂正取消
  order_future_list: 14, //先物建玉一覧
  order_future_buy: 15, //新規建注文
  order_future_repayment: 16, //返済注文
  order_future_history: 17, //注文照会・訂正取消
  order_option_list: 18, //OP建玉一覧
  order_option_buy: 19, //新規建注文
  order_option_repayment: 20, //返済注文
  order_option_history: 21, //注文照会・訂正取消
  order_mutual_list: 22, //投信残高一覧
  order_mutual_buy: 23, //買付/応募注文
  order_mutual_sell: 24, //売付注文
  order_mutual_history: 25, //注文照会・取消

  //マーケット
  market_top: 26,
  market_top_market: 27,
  market_top_news: 28,
  market_market_top: 29,
  market_market_top_statistic: 30,
  market_market_top_ranking: 31,
  market_market_tousyou: 32,
  market_market_jasdaq: 33,
  market_market_ratio: 34,
  market_market_situation: 35,
  market_market_calendar: 36,
  market_ranking_tousyou: 37,
  market_ranking_tousyouindex: 38,
  market_ranking_tousyoujq: 39,
  market_ranking_tousyoumothers: 40,
  market_ranking_stock: 41,
  market_ranking_credit: 42,
  market_ranking_business: 43,
  market_cerdit_balance: 44,
  market_cerdit_backwardation: 45,
  market_cerdit_shortstock: 46,
  market_cerdit_restriction: 47,
  market_event_new: 48,
  market_event_sign: 49,
  market_etfreit_etf: 50,
  market_etfreit_reit: 51,
  market_change_newstock: 52,
  market_change_new: 53,
  market_change_old: 54,
  market_change_suspension: 55,
  market_change_finance: 56,
  market_change_stable: 57,
  market_change_merger: 58,
  market_change_capital: 59,
  market_change_unit: 60,
  market_change_listng_change: 61,
  market_change_listng_suspension: 62,
  market_change_listng_delay: 63,
  market_change_businessname: 64,
  market_change_arrangement: 65,
  market_change_supervision: 66,
  market_future_index: 67,
  market_future_index_future: 68,
  market_future_index_option: 69,
  market_future_daily: 70,
  market_future_night: 71,
  market_future_summary: 72,
  market_future_position: 73,
  market_future_225daily: 74,
  market_future_225night: 75,
  market_overseas: 76,
  market_overseas_currency: 77,
  market_news: 78,
  market_screening: 79, //スクリーニング
  market_keyword_search: 80, //キーワード検索
  market_theme: 81, //テーマ検索
  market_incentives: 82, //株主優待検索
  market_comparision: 83,
  market_information: 84,
  market_simulation_deposit: 85,
  market_simulation_margin: 86,
  market_detail: 87,
  market_detail_contents: 88,
  market_gadget_index: 90,
  market_gadget_domestic_index: 91,
  market_gadget_news: 92,
  market_gadget_theme: 93,
  market_gadget_ranking_up: 94,
  market_gadget_ranking_down: 95,
  market_gadget_ranking_trading_value: 96,
  market_gadget_ranking_trading_price: 97,
  market_gadget_favorite: 98,
  market_gadget_history_stock: 99,

  //ボード
  board_option: 100,
  board_option_detail: 101,
  board_four_value_detail: 102,
  board_future: 103,
  board_speed: 104,
  board_plate: 105,
  board_sheet_list: 106,
  //テクニカルチャート
  tech_chart: 107,

  order_balance_loadingHistory: 108, //入出庫履歴
  order_home_deposits_inquiry: 109, //出金取り消し
  order_home_deposits_cancel: 110, //入出金照会
  order_option_future_receiveMarginHistory: 111, //先物OP受入証拠金履歴
  order_balance_foreignStocks: 112, //外国株式証券一覧
  order_balance_foreignBalanceBond: 113, //外国投信残高一覧
  order_balance_foreignCurrency: 114, //外貨MMF残高一覧
  order_balance_governmentBond: 115, //国内債券残高一覧
  order_balance_foreignBond: 116, //外国債券残高一覧
  order_balance_foreignExchange: 117, //外国債券残高一覧
  order_balance_nisaBond: 118, //NISA残高一覧
  order_balance_balanceDetail: 119, //特定口座損益明細
  order_balance_tradeHistory: 120, //取引履歴
  order_balance_tradeYearReport: 121, //先物・OP 年間損益計算書
  order_balance_buySellHistory: 122, //先物・OP権利行使履歴

  order_future_buy_edit: 123, //先物発注入力
  order_option_buy_edit: 124, //OP発注入力
  order_margin_change_future: 125, //余力照会(先物OP)
}

export class ChartColor {
  ColorSettings: object
  ColorSetting: object
  TechColorSetting: object
  ColorWhiteSettings: object
  ColorWhiteSetting: object
  TechColorWhiteSetting: object
  constructor() {
    this.ColorSettings = {
      baseColor: {
        line: {
          Line_Line: "rgb(2, 150, 136)",
        },
        lineFill: {
          LineFill_Line: "rgb(0, 204, 255)",
          LineFill_Top: "rgba(0, 204, 255, 1)",
          LineFill_Bottom: "rgba(0, 204, 255, 0)",

          LineFill_LineSame: "rgb(82, 85, 95)", //ライン(同値の時)
          LineFill_TopSame: "rgba(48, 67, 82, 0)",
          LineFill_BottomSame: "rgba(232, 230, 229, 0)",

          LineFill_LineUp: "rgb(241, 8, 90)", //ライン(あげ値の時)
          LineFill_TopUp: "rgba(241, 8, 90, 0)",
          LineFill_BottomUp: "rgba(251, 182, 207, 0)",

          LineFill_LineDown: "rgb(55, 148, 255)", //ライン(さげ値の時)
          LineFill_TopDown: "rgba(13, 14, 255, 0)",
          LineFill_BottomDown: "rgba(145, 214, 255, 0)",
        },
        scrollbar: {
          Scroll_Back: "rgba(39, 43, 55, 1)", //背景塗りつぶし(黒)
          Scroll_ViewRange: "rgba(155, 155, 155, 0.6)", //表示範囲暗(白透過)
          Scroll_ViewRangeLight: "rgba(155, 155, 155, 0.2)", //表示範囲明(透過)
          Scroll_Data: "rgba(40, 135, 139, 0.2)", //データ塗りつぶし(青)
          Scroll_DataLine: "rgba(40, 135, 139, 0.8)", //データライン(青)
          Scroll_HandleMark: "rgba(0, 0, 0, 0.5)", //ハンドルマーク(淡灰)
          Scroll_HandleBorder: "rgba(82, 85, 95, 1)", //ハンドルサイドノブ(淡灰)
        },
        candle: {
          Candle_UpArea: "rgba(219, 82, 75, 0.5)", // 陽線(赤)
          Candle_UpFrame: "rgb(219, 82, 75)", //ローソク陽線枠
          Candle_DownArea: "rgba(58, 167, 255, 0.5)", // 陰線(青)
          Candle_DownFrame: "rgb(58, 167, 255)", //ローソク陰線枠
        },
        area: {
          ChartFill: "rgba(29, 32, 41, 1)",
          AreaFill: "rgba(16, 18, 23, 1)",
          AreaDraw: "rgba(255, 255, 255, 0.1)", //数値読取
          Grid: "rgba(82, 85, 95, 0.25)",
          SubChartLabel: "rgb(255, 255, 255)",
          Label: "rgba(255, 255, 255, 1)",
          CK_ScaleLine: "rgba(255, 255, 255, 0.2)",

          CrossCursolLine: "rgba(63, 135, 237, 1)", // クロスカーソル(青）
          CrossCursolLblDraw: "rgba(255, 255, 255, 1)", // クロスカーソル(文字白）
          CrossCursolLblFill: "rgba(63, 135, 237, 1)", // クロスカーソル(青）

          CurPriceLblFill: "rgba(253, 12, 96, 1)", // 現値ラベル(赤系）
          CurPriceLblDraw: "rgba(255, 255, 255, 1)", // 現値ラベル(白）

          PrevDayCloseLine: "rgba(63, 135, 237, 1)", // 前日終値ライン(青）
          PrevDayCloseLblFill: "rgba(63, 135, 237, 1)", // 前日終値ライン(青）
          PrevDayCloseLblDraw: "rgba(255, 255, 255, 1)", // 前日終値ライン(白）
        },
        compChart: {
          // スプレッドの色に合わせている
          subBrand1: "rgb(0, 204, 255)", // 陽線(シアン）
          subBrand2: "rgb(0, 204, 0)", // 陰線(緑)
        },
      },
      toolColor: {
        trendLine: {
          TrendLine: "rgba(255, 255, 255, 1)",
          CK_HANDLINGDRAINGITEM: "rgba(63, 224, 85, 1)",
        },
        loupe: {
          CK_LOUPEFRAME: "rgba(255, 255, 255, 0.2)", //ルーペ拡大時(白透過)
          CK_LOUPE_RESET: "rgba(0, 0, 255, 0.2)", //ルーペ リセット時(青透過)
        },
        control: {
          CK_INNERAREAHANDLE: "rgb(255, 255, 255)",
        },
        PandF: {
          PAndF_Down: "rgb(60, 120, 255)",
          PAndF_Up: "rgb(241, 8, 90)",
        },
        Fibo: {
          FiboReTracement: "rgb(255, 255, 0);1", // フィボナッチ・リトレースメント
          FiboExpansion: "rgb(102, 255, 0);1", // フィボナッチ・エクスパンション
          FiboTimeZone: "rgb(0, 255, 255);1", // フィボナッチ・タイムゾーン
          FiboFan: "rgb(255, 102, 0);1", // フィボナッチ・ファン
          FiboArc: "rgb(255, 51, 255);1", // フィボナッチ・アーク
        },
        Gann: {
          GannFan: "rgb(238, 0, 119);1", //　ギャン・ファン
          GannGrid: "rgb(238, 0, 119);1", // ギャン・グリッド
        },
        Mado: {
          MadoBackGroundUp: "rgba(255, 0, 0, 0.4)", //　窓上昇
          MadoBackGroundDown: "rgba(0, 51, 255, 0.4)", // 窓下降
          MadoValue: "rgb(255, 255, 255)", // 窓文字色
        },
      },
      addon: {
        Average3: {
          Short: "rgb(244, 112, 32);1",
          Middle: "rgb(127, 244, 32);1",
          Long: "rgb(32, 232, 244);1",
        },
        AverageN: {
          Ma1: "rgb(255, 204, 0);1",
          Ma2: "rgb(255, 102, 0);1",
          Ma3: "rgb(0, 204, 255);1",
          Ma4: "rgb(255, 51, 255);1",
          Ma5: "rgb(0, 204, 0);1",
        },
        Ichimoku: {
          KijunLine: "rgb(255, 102, 0);1",
          TenkanLine: "rgb(0, 204, 255);1",
          PrecedLine1: "rgb(255, 102, 153)",
          PrecedLine2: "rgb(102, 153, 255)",
          DelayLine: "rgb(255, 204, 0);1",
          Kumo: "rgba(255, 102, 153, 0.5)",
          Kumo2: "rgba(102, 153, 255, 0.5)",
        },
        Envelope: {
          EnvSigma1: "rgb(204, 153, 255);1",
          EnvSigma2: "rgb(204, 102, 255);1",
          EnvSigma3: "rgb(153, 0, 255);1",
          EnvSigma1m: "rgb(204, 153, 255);1",
          EnvSigma2m: "rgb(204, 102, 255);1",
          EnvSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Bolinger: {
        //   BolSigma1: "rgb(196, 196, 245);1",
        //   BolSigma2: "rgb(142,142,237);1",
        //   BolSigma3: "rgb(92,92,229);1",
        //   BolSigma1m: "rgb(196, 196, 245);1",
        //   BolSigma2m: "rgb(142,142,237);1",
        //   BolSigma3m: "rgb(92,92,229);1",
        //   Sma: "rgb(244,241,32);1",
        // },
        KSBolinger: {
          BolSigma1: "rgb(204, 153, 255);1",
          BolSigma2: "rgb(204, 102, 255);1",
          BolSigma3: "rgb(153, 0, 255);1",
          BolSigma1m: "rgb(204, 153, 255);1",
          BolSigma2m: "rgb(204, 102, 255);1",
          BolSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Parabolic: {
        //   Parabolic: "rgb(250, 223, 86)",
        // },
        ParabolicDiv: {
          CircleBuy: "rgb(255, 51, 102)",
          CircleSell: "rgb(51, 153, 255)",
        },
        HLBand: {
          Center: "rgb(0, 204, 0);1",
          HLine: "rgb(255, 51, 102);1",
          LLine: "rgb(255, 51, 102);1",
        },
        ATRChannel: {
          ATRChannelSigma1: "rgb(204, 153, 255);1",
          ATRChannelSigma2: "rgb(204, 102, 255);1",
          ATRChannelSigma3: "rgb(153, 0, 255);1",
          ATRChannelSigma1m: "rgb(204, 153, 255);1",
          ATRChannelSigma2m: "rgb(204, 102, 255);1",
          ATRChannelSigma3m: "rgb(153, 0, 255);1",
          Lma: "rgb(255, 204, 0);1",
        },
        EMA: {
          Short: "rgb(255, 102, 0);1",
          Middle: "rgb(0, 204, 0);1",
          Long: "rgb(0, 204, 255);1",
        },
        Kaiki: {
          KaikiSigma1: "rgb(204, 153, 255);1",
          KaikiSigma2: "rgb(204, 102, 255);1",
          KaikiSigma3: "rgb(153, 0, 255);1",
          KaikiSigma1m: "rgb(204, 153, 255);1",
          KaikiSigma2m: "rgb(204, 102, 255);1",
          KaikiSigma3m: "rgb(153, 0, 255);1",
          Kaiki: "rgb(255, 204, 0);1",
        },
        Vwap: {
          Vwap: "rgb(255, 102, 0);1",
        },
        tenkan: {
          Tenkan_Label: "rgb(255, 255, 255)",
          Tenkan_Draw: "rgba(36, 24, 24, 1)",
          Tenkan_Fill: "rgba(51, 51, 77, 0.5)",
        },
        CycleAna: {
          CycleHigh: "rgb(255, 0, 255)", // 日柄分析(上げ)
          CycleLow: "rgb(0, 255, 255)", // 日柄分析(下げ)
          CycleHighFont: "rgb(255, 255, 255)", // 日柄分析(上げ値)
          CycleLowFont: "rgb(255, 255, 255)", // 日柄分析(下げ値)
        },
        PriceVolume: {
          PriceVolume: "rgba(51, 153, 255, 0.5)", // 価格帯別出来高(グラフ）
          PvMaxVolume: "rgba(255, 0, 153, 0.5)", // 価格帯別出来高(最大グラフ）
          PvMaxNum: "rgba(255, 255, 255, 1)", // 価格帯別出来高(最大値）
          PvMaxNumBack: "rgba(255, 0, 153, 0.5)", // 価格帯別出来高(背景）
        },
      },
      sub: {
        RSI: {
          RSI: "rgb(255, 0, 157);1",
        },
        Stocast: {
          PercentK: "rgb(62, 244, 32);1",
          PercentD: "rgb(32, 162, 244);1",
          SPercentD: "rgb(32, 244, 222);1",
        },
        StocastKD: {
          PercentK: "rgb(62, 244, 32);1",
          PercentD: "rgb(32, 162, 244);1",
        },
        StocastDS: {
          PercentD: "rgb(32, 162, 244);1",
          SPercentD: "rgb(32, 244, 222);1",
        },
        PercentR: {
          PercentR: "rgb(255, 106, 0);1",
        },
        MACD: {
          MACD: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
          OSCI: "rgb(255, 170, 85);1",
        },
        RCI: {
          RCI: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
        },
        RCI3: {
          RCI1: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
          RCI3: "rgb(0, 187, 255);1",
        },
        CCI: {
          CCI: "rgb(255, 106, 0);1",
        },
        PsyCologic: {
          PsyCologic: "rgb(242, 65, 157);1",
        },
        ROC: {
          ROC: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ROC2: {
          ROC1: "rgb(255, 0, 157);1",
          ROC2: "rgb(0, 204, 0);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ATR: {
          ATR: "rgb(0, 204, 0);1",
        },
        Momentum: {
          Momentum: "rgb(242, 65, 157);1",
          Momentum2: "rgb(0, 187, 255);1",
          Momentum3: "rgb(255, 251, 0);1",
          Momentum4: "rgb(0, 255, 0);1",
        },
        MomentumS: {
          Momentum: "rgb(242, 65, 157);1",
          Signal: "rgb(0, 128, 0);1",
        },
        DMI: {
          "+DI": "rgb(255, 0, 157);1",
          "-DI": "rgb(0, 187, 255);1",
          ADX: "rgb(149, 0, 255);1",
          ADXR: "rgb(0, 255, 4);1",
        },
        DMImod: {
          "+DI": "rgb(255, 0, 153);1",
          "-DI": "rgb(0, 204, 255);1",
          ADX1: "rgb(153, 0, 255);1",
          ADXR1: "rgb(0, 204, 0);1",
          ADX2: "rgb(255, 102, 0);1",
          ADXR2: "rgb(255, 204, 0);1",
        },
        AroonIndi: {
          AroonUp: "rgb(255, 0, 157);1",
          AroonDown: "rgb(0, 187, 255);1",
        },
        AroonOsci: {
          AroonOsci: "rgb(255, 106, 0);1",
        },
        Kairi3: {
          Short: "rgb(242, 65, 157);1",
          Middle: "rgb(62, 244, 32);1",
          Long: "rgb(32, 162, 244);1",
        },
        Volume: {
          Volume: "rgb(244, 32, 244);1",
          Short: "rgb(242, 65, 157);1",
          Middle: "rgb(62, 244, 32);1",
          Long: "rgb(32, 162, 244);1",
          Today: "rgb(0, 187, 255);1",
        },
        SinyouZan: {
          MarginBuying: "rgb(255, 34, 34);1",
          MarginSelling: "rgb(30, 100, 255);1",
        },
        // 標準偏差ボラティリティ
        StandardDeviation: {
          StandardDeviation: "rgb(242, 65, 157);1",
        },
        // 強弱レシオ
        HinoharaRatio: {
          RatioA: "rgb(242, 65, 157);1",
          RatioB: "rgb(62, 244, 32);1",
        },
        // 対比チャート用スプレッド
        Spread: {
          Spread1: "rgb(0, 255, 255);1",
          Spread2: "rgb(0, 255, 0);1",
        },
      },
    }
    this.ColorSetting = {
      baseColor: {
        line: {
          Line_Line: "rgb(2, 150, 136)",
        },
        lineFill: {
          LineFill_Line: "rgb(0, 204, 255)",
          LineFill_Top: "rgba(0, 204, 255, 1)",
          LineFill_Bottom: "rgba(0, 204, 255, 0)",
        },
        scrollbar: {
          Scroll_Back: "rgba(255, 255, 255, 1)",
          Scroll_ViewRange: "rgba(215, 215, 215, 0.6)",
          Scroll_ViewRangeLight: "rgba(230, 230, 230, 0.4)",
          Scroll_Data: "rgba(40, 135, 139, 0.2)",
          Scroll_DataLine: "rgba(40, 135, 139, 0.6)",
          Scroll_HandleMark: "rgba(110, 110, 110, 0.8)",
          Scroll_HandleBorder: "rgba(222, 222, 225, 1)",
        },
        candle: {
          Candle_UpArea: "rgba(219, 82, 75, 0.5)",
          Candle_UpFrame: "rgb(219, 82, 75)",
          Candle_DownArea: "rgba(58, 167, 255, 0.5)", // 陰線(青)
          Candle_DownFrame: "rgb(58, 167, 255)", //ローソク陰線枠
        },
        area: {
          ChartFill: "rgba(29, 32, 41, 1)",
          AreaFill: "rgba(16, 18, 23, 1)",
          AreaDraw: "rgba(255, 255, 255, 0.1)",
          Grid: "rgba(82, 85, 95, 0.25)",
          SubChartLabel: "rgb(255, 255, 255)",
          Label: "rgba(255, 255, 255, 1)",
          CK_ScaleLine: "rgba(255, 255, 255, 0.2)",
          CrossCursolLine: "rgba(63, 135, 237, 1)",
          CrossCursolLblDraw: "rgba(255, 255, 255, 1)",
          CrossCursolLblFill: "rgba(63, 135, 237, 1)",
        },
        compChart: {
          subBrand1: "rgb(0, 204, 255)",
          subBrand2: "rgb(0, 204, 0)",
        },
      },
      toolColor: {
        trendLine: {
          TrendLine: "rgba(255, 255, 255, 1)",
          CK_HANDLINGDRAINGITEM: "rgba(63, 224, 85, 1)",
        },
        loupe: {
          CK_LOUPEFRAME: "rgba(255, 255, 255, 0.2)", //ルーペ拡大時(白透過)
        },
        control: {
          CK_INNERAREAHANDLE: "rgb(255, 255, 255)",
        },
        PandF: {
          PAndF_Down: "rgb(60, 120, 255)",
          PAndF_Up: "rgb(241, 8, 90)",
        },
        Fibo: {
          FiboReTracement: "rgb(255, 255, 0);1", // フィボナッチ・リトレースメント
          FiboExpansion: "rgb(102, 255, 0);1", // フィボナッチ・エクスパンション
          FiboTimeZone: "rgb(0, 255, 255);1", // フィボナッチ・タイムゾーン
          FiboFan: "rgb(255, 102, 0);1", // フィボナッチ・ファン
          FiboArc: "rgb(255, 51, 255);1", // フィボナッチ・アーク
        },
        Gann: {
          GannFan: "rgb(238, 0, 119);1", //　ギャン・ファン
          GannGrid: "rgb(238, 0, 119);1", // ギャン・グリッド
        },
        Mado: {
          MadoBackGroundUp: "rgba(255, 0, 0, 0.4)", //　窓上昇
          MadoBackGroundDown: "rgba(0, 51, 255, 0.4)", // 窓下降
          MadoValue: "rgb(255, 255, 255)", // 窓文字色
        },
      },
    }
    this.TechColorSetting = {
      addon: {
        AverageN: {
          Ma1: "rgb(255, 204, 0);1",
          Ma2: "rgb(255, 102, 0);1",
          Ma3: "rgb(0, 204, 255);1",
          Ma4: "rgb(255, 51, 255);1",
          Ma5: "rgb(0, 204 ,0);1",
        },
        Ichimoku: {
          KijunLine: "rgb(255, 102, 0);1",
          TenkanLine: "rgb(0, 204, 255);1",
          PrecedLine1: "rgb(255, 102, 153)",
          PrecedLine2: "rgb(102, 153, 255)",
          DelayLine: "rgb(255, 204, 0);1",
          Kumo: "rgba(255, 102, 153, 0.5)",
          Kumo2: "rgba(102, 153, 255, 0.5)",
        },
        Envelope: {
          EnvSigma1: "rgb(204, 153, 255);1",
          EnvSigma2: "rgb(204, 102, 255);1",
          EnvSigma3: "rgb(153, 0, 255);1",
          EnvSigma1m: "rgb(204, 153, 255);1",
          EnvSigma2m: "rgb(204, 102, 255);1",
          EnvSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        KSBolinger: {
          BolSigma1: "rgb(204, 153, 255);1",
          BolSigma2: "rgb(204, 102, 255);1",
          BolSigma3: "rgb(153, 0, 255);1",
          BolSigma1m: "rgb(204, 153, 255);1",
          BolSigma2m: "rgb(204, 102, 255);1",
          BolSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Parabolic: {
        //   Parabolic: "rgb(250, 223, 86)",
        // },
        ParabolicDiv: {
          CircleBuy: "rgb(255, 51, 102)",
          CircleSell: "rgb(51, 153, 255)",
        },
        HLBand: {
          Center: "rgb(0, 204, 0);1",
          HLine: "rgb(255, 51, 102);1",
          LLine: "rgb(255, 51, 102);1",
        },
        ATRChannel: {
          ATRChannelSigma1: "rgb(204, 153, 255);1",
          ATRChannelSigma2: "rgb(204, 102, 255);1",
          ATRChannelSigma3: "rgb(153, 0, 255);1",
          ATRChannelSigma1m: "rgb(204, 153, 255);1",
          ATRChannelSigma2m: "rgb(204, 102, 255);1",
          ATRChannelSigma3m: "rgb(153, 0, 255);1",
          Lma: "rgb(255, 204, 0);1",
        },
        EMA: {
          Short: "rgb(255, 102, 0);1",
          Middle: "rgb(0, 204, 0);1",
          Long: "rgb(0, 204, 255);1",
        },
        Kaiki: {
          KaikiSigma1: "rgb(204, 153, 255);1",
          KaikiSigma2: "rgb(204, 102, 255);1",
          KaikiSigma3: "rgb(153, 0, 255);1",
          KaikiSigma1m: "rgb(204, 153, 255);1",
          KaikiSigma2m: "rgb(204, 102, 255);1",
          KaikiSigma3m: "rgb(153, 0, 255);1",
          Kaiki: "rgb(255, 204, 0);1",
        },
        Vwap: {
          Vwap: "rgb(255, 102, 0);1",
        },
        tenkan: {
          Tenkan_Label: "rgb(255, 255, 255)",
          Tenkan_Draw: "rgba(36, 24, 24, 1)",
          Tenkan_Fill: "rgba(51, 51, 77, 0.5)",
        },
        CycleAna: {
          CycleHigh: "rgb(255, 0, 255)", // 日柄分析(上げ)
          CycleLow: "rgb(0, 255, 255)", // 日柄分析(下げ)
          CycleHighFont: "rgb(255, 255, 255)", // 日柄分析(上げ値)
          CycleLowFont: "rgb(255, 255, 255)", // 日柄分析(下げ値)
        },
        PriceVolume: {
          PriceVolume: "rgba(51, 153, 255, 0.5)", // 価格帯別出来高(グラフ）
          PvMaxVolume: "rgba(255, 0, 153, 0.5)", // 価格帯別出来高(最大グラフ）
          PvMaxNum: "rgba(255, 255, 255, 1)", // 価格帯別出来高(最大値）
          PvMaxNumBack: "rgba(255, 0, 153, 0.5)", // 価格帯別出来高(背景）
        },
      },
      sub: {
        RSI: {
          RSI: "rgb(255, 0, 157);1",
        },
        Stocast: {
          PercentK: "rgb(62, 244, 32);1",
          PercentD: "rgb(32, 162, 244);1",
          SPercentD: "rgb(32, 244, 222);1",
        },
        StocastKD: {
          PercentK: "rgb(62, 244, 32);1",
          PercentD: "rgb(32, 162, 244);1",
        },
        StocastDS: {
          PercentD: "rgb(32, 162, 244);1",
          SPercentD: "rgb(32, 244, 222);1",
        },
        PercentR: {
          PercentR: "rgb(255, 106, 0);1",
        },
        MACD: {
          MACD: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
          OSCI: "rgb(255, 170, 85);1",
        },
        RCI: {
          RCI: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
        },
        RCI3: {
          RCI1: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
          RCI3: "rgb(0, 187, 255);1",
        },
        CCI: {
          CCI: "rgb(255, 106, 0);1",
        },
        PsyCologic: {
          PsyCologic: "rgb(242, 65, 157);1",
        },
        ROC: {
          ROC: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ROC2: {
          ROC1: "rgb(255, 0, 157);1",
          ROC2: "rgb(0, 204, 0);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ATR: {
          ATR: "rgb(0, 204, 0);1",
        },
        Momentum: {
          Momentum: "rgb(242, 65, 157);1",
          Momentum2: "rgb(0, 187, 255);1",
          Momentum3: "rgb(255, 251, 0);1",
          Momentum4: "rgb(0, 255, 0);1",
        },
        MomentumS: {
          Momentum: "rgb(242, 65, 157);1",
          Signal: "rgb(0, 128, 0);1",
        },
        DMI: {
          "+DI": "rgb(255, 0, 157);1",
          "-DI": "rgb(0, 187, 255);1",
          ADX: "rgb(149, 0, 255);1",
          ADXR: "rgb(0, 255, 4);1",
        },
        DMImod: {
          "+DI": "rgb(255, 0, 153);1",
          "-DI": "rgb(0, 204, 255);1",
          ADX1: "rgb(153, 0, 255);1",
          ADXR1: "rgb(0, 204, 0);1",
          ADX2: "rgb(255, 102, 0);1",
          ADXR2: "rgb(255, 204, 0);1",
        },
        AroonIndi: {
          AroonUp: "rgb(255, 0, 157);1",
          AroonDown: "rgb(0, 187, 255);1",
        },
        AroonOsci: {
          AroonOsci: "rgb(255, 106, 0);1",
        },
        Kairi3: {
          Short: "rgb(242, 65, 157);1",
          Middle: "rgb(62, 244, 32);1",
          Long: "rgb(32, 162, 244);1",
        },
        Volume: {
          Volume: "rgb(244, 32, 244);1",
          Short: "rgb(242, 65, 157);1",
          Middle: "rgb(62, 244, 32);1",
          Long: "rgb(32, 162, 244);1",
          Today: "rgb(0, 187, 255);1",
        },
        SinyouZan: {
          MarginBuying: "rgb(255, 34, 34);1",
          MarginSelling: "rgb(30, 100, 255);1",
        },
        // 標準偏差ボラティリティ
        StandardDeviation: {
          StandardDeviation: "rgb(242, 65, 157);1",
        },
        // 強弱レシオ
        HinoharaRatio: {
          RatioA: "rgb(242, 65, 157);1",
          RatioB: "rgb(62, 244, 32);1",
        },
        // 対比チャート用スプレッド
        Spread: {
          Spread1: "rgb(0, 255, 255);1",
          Spread2: "rgb(0, 255, 0);1",
        },
      },
    }
    this.ColorWhiteSettings = {
      baseColor: {
        line: {
          Line_Line: "rgb(238, 0, 119)", //ライン
        },
        lineFill: {
          LineFill_Line: "rgb(0, 204, 255)", //ライン
          LineFill_Top: "rgba(0, 204, 255, 1)", //グラデーション（上）
          LineFill_Bottom: "rgba(0, 204, 255, 0)", // グラデーション（下）

          LineFill_LineSame: "rgb(82, 85, 95)", //ライン(同じ値の時)
          LineFill_TopSame: "rgba(48, 67, 82, 0)",
          LineFill_BottomSame: "rgba(232, 230, 229, 0)",

          LineFill_LineUp: "rgb(241, 8, 90)", //ライン(あげ値の時)
          LineFill_TopUp: "rgb(241, 8, 90)",
          LineFill_BottomUp: "rgba(251, 182, 207, 0)",

          LineFill_LineDown: "rgb(55, 148, 255)", //ライン(さげ値の時)
          LineFill_TopDown: "rgb(13, 14, 255)",
          LineFill_BottomDown: "rgba(145, 214, 255, 0)",
        },
        scrollbar: {
          Scroll_Back: "rgba(255, 255, 255, 1)", //背景塗りつぶし(黒)
          Scroll_ViewRange: "rgba(215, 215, 215, 0.6)", //表示範囲暗(白透過)
          Scroll_ViewRangeLight: "rgba(230, 230, 230, 0.4)", //表示範囲明(透過)
          Scroll_Data: "rgba(40, 135, 139, 0.2)", //データ塗りつぶし(青)
          Scroll_DataLine: "rgba(40, 135, 139, 0.6)", //データライン(青)
          Scroll_HandleMark: "rgba(110, 110, 110, 0.8)", //ハンドルマーク(淡灰)
          Scroll_HandleBorder: "rgba(222, 222, 225, 1)", //ハンドルサイドノブ(淡灰)
        },
        candle: {
          Candle_UpArea: "rgba(219, 82, 75, 0.5)", // 陽線(赤)
          Candle_UpFrame: "rgb(219, 82, 75)", //ローソク陽線枠
          Candle_DownArea: "rgba(58, 167, 255, 0.5)", // 陰線(青)
          Candle_DownFrame: "rgb(58, 167, 255)", //ローソク陰線枠
        },
        area: {
          ChartFill: "rgba(246, 246, 248, 1)", //エリア外塗りつぶし
          AreaFill: "rgba(255, 255, 255, 1)", //エリア内塗りつぶし
          AreaDraw: "rgba(0, 0, 0, 0.5)", //数値読取
          Grid: "rgba(221, 221, 221, 0.25)", //グリッド
          SubChartLabel: "rgb(7, 19, 57)", // X軸、Y軸のラベル表示
          Label: "rgba(7, 19, 57, 1)", //サブチャートラベル
          CK_ScaleLine: "rgba(0, 0, 0, 0.2)", //スケールライン

          CrossCursolLine: "rgba(63, 135, 237, 1)", // クロスカーソル(青）
          CrossCursolLblDraw: "rgba(255, 255, 255, 1)", // クロスカーソル(文字白）
          CrossCursolLblFill: "rgba(63, 135, 237, 1)", // クロスカーソル(青）

          CurPriceLblFill: "rgba(253, 12, 96, 1)", // 現値ラベル(赤系）
          CurPriceLblDraw: "rgba(255, 255, 255, 1)", // 現値ラベル(白）

          PrevDayCloseLine: "rgba(63, 135, 237, 1)", // 前日終値ライン(青）
          PrevDayCloseLblFill: "rgba(63, 135, 237, 1)", // 前日終値ライン(青）
          PrevDayCloseLblDraw: "rgba(255, 255, 255, 1)", // 前日終値ライン(白）
        },
        compChart: {
          // スプレッドの色に合わせている
          subBrand1: "rgb(0, 204, 255)", // 陽線(シアン）
          subBrand2: "rgb(0, 204, 0)", // 陰線(緑)
        },
      },
      toolColor: {
        trendLine: {
          TrendLine: "rgba(7, 19, 57, 1);1", //トレンドライン
          CK_HANDLINGDRAINGITEM: "rgba(63, 224, 85, 1)",
        },
        loupe: {
          CK_LOUPEFRAME: "rgba(0, 0, 0, 0.2)", //ルーペ拡大時(黒透過)
          CK_LOUPE_RESET: "rgba(0, 0, 255, 0.2)", //ルーペ リセット時(青透過)
        },
        control: {
          //操作時
          CK_INNERAREAHANDLE: "rgb(7, 19, 57)",
        },
        PandF: {
          PAndF_Down: "rgb(60, 120, 255)",
          PAndF_Up: "rgb(241, 8, 90)",
        },
        Fibo: {
          FiboReTracement: "rgb(255, 153, 0);1", // フィボナッチ・リトレースメント
          FiboExpansion: "rgb(0, 204, 0);1", // フィボナッチ・エクスパンション
          FiboTimeZone: "rgb(0, 51, 255);1", // フィボナッチ・タイムゾーン
          FiboFan: "rgb(255, 102, 0);1", // フィボナッチ・ファン
          FiboArc: "rgb(255, 51, 255);1", // フィボナッチ・アーク
        },
        Gann: {
          GannFan: "rgb(238, 0, 119);1", //　ギャン・ファン
          GannGrid: "rgb(238, 0, 119);1", // ギャン・グリッド
        },
        Mado: {
          MadoBackGroundUp: "rgba(255, 0, 0, 0.4)", //　窓上昇
          MadoBackGroundDown: "rgba(0, 51, 255, 0.4)", // 窓下降
          MadoValue: "rgb(0, 0, 0)", // 窓文字色
        },
      },
      addon: {
        Average3: {
          Short: "rgb(219, 94, 45);1",
          Middle: "rgb(106, 219, 45);1",
          Long: "rgb(45, 201, 219);1",
        },
        AverageN: {
          Ma1: "rgb(255, 204, 0);1",
          Ma2: "rgb(255, 102, 0);1",
          Ma3: "rgb(0, 204, 255);1",
          Ma4: "rgb(255, 51, 255);1",
          Ma5: "rgb(0, 204, 0);1",
        },
        Ichimoku: {
          KijunLine: "rgb(255, 102, 0);1",
          TenkanLine: "rgb(0, 204, 255);1",
          PrecedLine1: "rgb(255, 102, 153)",
          PrecedLine2: "rgb(102, 153, 255)",
          DelayLine: "rgb(255, 204, 0);1",
          Kumo: "rgba(255, 102, 153, 0.5)",
          Kumo2: "rgba(102, 153, 255, 0.5)",
        },
        Envelope: {
          EnvSigma1: "rgb(204, 153, 255);1",
          EnvSigma2: "rgb(204, 102, 255);1",
          EnvSigma3: "rgb(153, 0, 255);1",
          EnvSigma1m: "rgb(204, 153, 255);1",
          EnvSigma2m: "rgb(204, 102, 255);1",
          EnvSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Bolinger: {
        //   BolSigma1: "rgb(170,153,214);1",
        //   BolSigma2: "rgb(130,95,218);1",
        //   BolSigma3: "rgb(94,45,219);1",
        //   BolSigma1m: "rgb(170,153,214);1",
        //   BolSigma2m: "rgb(130,95,218);1",
        //   BolSigma3m: "rgb(94,45,219);1",
        //   Sma: "rgb(219,196,45);1",
        // },
        KSBolinger: {
          BolSigma1: "rgb(204, 153, 255);1",
          BolSigma2: "rgb(204, 102, 255);1",
          BolSigma3: "rgb(153, 0, 255);1",
          BolSigma1m: "rgb(204, 153, 255);1",
          BolSigma2m: "rgb(204, 102, 255);1",
          BolSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Parabolic: {
        //   Parabolic: "rgb(250, 223, 86)",
        // },
        ParabolicDiv: {
          CircleBuy: "rgb(255, 51, 102)",
          CircleSell: "rgb(51, 153, 255)",
        },
        HLBand: {
          Center: "rgb(0, 204, 0);1",
          HLine: "rgb(255, 51, 102);1",
          LLine: "rgb(255, 51, 102);1",
        },
        ATRChannel: {
          ATRChannelSigma1: "rgb(204, 153, 255);1",
          ATRChannelSigma2: "rgb(204, 102, 255);1",
          ATRChannelSigma3: "rgb(153, 0, 255);1",
          ATRChannelSigma1m: "rgb(204, 153, 255);1",
          ATRChannelSigma2m: "rgb(204, 102, 255);1",
          ATRChannelSigma3m: "rgb(153, 0, 255);1",
          Lma: "rgb(255, 204, 0);1",
        },
        EMA: {
          Short: "rgb(255, 102, 0);1",
          Middle: "rgb(0, 204, 0);1",
          Long: "rgb(0, 204, 255);1",
        },
        Kaiki: {
          KaikiSigma1: "rgb(204, 153, 255);1",
          KaikiSigma2: "rgb(204, 102, 255);1",
          KaikiSigma3: "rgb(153, 0, 255);1",
          KaikiSigma1m: "rgb(204, 153, 255);1",
          KaikiSigma2m: "rgb(204, 102, 255);1",
          KaikiSigma3m: "rgb(153, 0, 255);1",
          Kaiki: "rgb(255, 204, 0);1",
        },
        Vwap: {
          Vwap: "rgb(255, 102, 0);1",
        },
        tenkan: {
          //転換点
          Tenkan_Label: "rgb(7, 19, 57)",
          Tenkan_Draw: "rgba(36, 24, 24, 1)",
          Tenkan_Fill: "rgba(51, 51, 77, 0.5)",
        },
        CycleAna: {
          CycleHigh: "rgb(255, 0, 255)", // 日柄分析(上げ)
          CycleLow: "rgb(0, 255, 255)", // 日柄分析(下げ)
          CycleHighFont: "rgb(0, 0, 0)", // 日柄分析(上げ値)
          CycleLowFont: "rgb(0, 0, 0)", // 日柄分析(下げ値)
        },
        PriceVolume: {
          PriceVolume: "rgba(51, 102, 255, 0.5)", // 価格帯別出来高(グラフ）
          PvMaxVolume: "rgba(255, 0, 51, 0.5)", // 価格帯別出来高(最大グラフ）
          PvMaxNum: "rgba(0, 0, 0, 1)", // 価格帯別出来高(最大値）
          PvMaxNumBack: "rgba(255, 0, 51, 0.6)", // 価格帯別出来高(背景）
        },
      },
      sub: {
        RSI: {
          RSI: "rgb(255, 0, 157);1",
        },
        StocastKD: {
          PercentK: "rgb(45, 219, 49);1",
          PercentD: "rgb(45, 156, 219);1",
        },
        StocastDS: {
          PercentD: "rgb(45, 156, 219);1",
          SPercentD: "rgb(45, 217, 219);1",
        },
        PercentR: {
          PercentR: "rgb(255, 106, 0);1",
        },
        MACD: {
          MACD: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
          OSCI: "rgb(255, 170, 85);1",
        },
        RCI3: {
          RCI1: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
          RCI3: "rgb(45, 217, 219);1",
        },
        CCI: {
          CCI: "rgb(255, 106, 0);1",
        },
        PsyCologic: {
          PsyCologic: "rgb(219, 45, 143);1",
        },
        ROC2: {
          ROC1: "rgb(255, 0, 157);1",
          ROC2: "rgb(0, 204, 0);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ATR: {
          ATR: "rgb(0, 204, 0);1",
        },
        MomentumS: {
          Momentum: "rgb(219, 45, 143);1",
          Signal: "rgb(0, 187, 255);1",
        },
        DMImod: {
          "+DI": "rgb(255, 0, 153);1",
          "-DI": "rgb(0, 204, 255);1",
          ADX1: "rgb(153, 0, 255);1",
          ADXR1: "rgb(0, 204, 0);1",
          ADX2: "rgb(255, 102, 0);1",
          ADXR2: "rgb(255, 204, 0);1",
        },
        AroonIndi: {
          AroonUp: "rgb(255, 0, 157);1",
          AroonDown: "rgb(0, 187, 255);1",
        },
        AroonOsci: {
          AroonOsci: "rgb(255, 106, 0);1",
        },
        Kairi3: {
          Short: "rgb(219, 45, 143);1",
          Middle: "rgb(45, 219, 49);1",
          Long: "rgb(45, 156, 219);1",
        },
        Volume: {
          Today: "rgb(0, 187, 255);1",
          Volume: "rgb(201, 45, 219);1", // c92ddb(201,45,219)
          Short: "rgb(219, 45, 143);1", //b2d8f (219,45,143)
          Middle: "rgb(45, 219, 49);1", //2ddb31 (45,219,49)
          Long: "rgb(45, 156, 219);1", //2d9cdb  (45,156,219)
        },
        SinyouZan: {
          MarginBuying: "rgb(255, 34, 34);1",
          MarginSelling: "rgb(30, 100, 255);1",
        },
        // 標準偏差ボラティリティ
        StandardDeviation: {
          StandardDeviation: "rgb(242, 65, 157);1",
        },
        // 強弱レシオ
        HinoharaRatio: {
          RatioA: "rgb(242, 65, 157);1",
          RatioB: "rgb(62, 244, 32);1",
        },
        // 対比チャート用スプレッド
        Spread: {
          Spread1: "rgb(0, 255, 255);1",
          Spread2: "rgb(0, 255, 0);1",
        },
      },
    }
    this.ColorWhiteSetting = {
      baseColor: {
        line: {
          Line_Line: "rgb(238, 0, 119)",
        },
        lineFill: {
          LineFill_Line: "rgb(0, 204, 255)",
          LineFill_Top: "rgba(0, 204, 255, 1)",
          LineFill_Bottom: "rgba(0, 204, 255, 0)",
        },
        scrollbar: {
          Scroll_Back: "rgba(255, 255, 255, 1)",
          Scroll_ViewRange: "rgba(215, 215, 215, 0.6)",
          Scroll_ViewRangeLight: "rgba(230, 230, 230, 0.4)",
          Scroll_Data: "rgba(40, 135, 139, 0.2)",
          Scroll_DataLine: "rgba(40, 135, 139, 0.6)",
          Scroll_HandleMark: "rgba(110, 110, 110, 0.8)",
          Scroll_HandleBorder: "rgba(222, 222, 225, 1)",
        },
        candle: {
          Candle_UpArea: "rgba(219, 82, 75, 0.5)",
          Candle_UpFrame: "rgb(219, 82, 75)",
          Candle_DownArea: "rgba(58, 167, 255, 0.5)", // 陰線(青)
          Candle_DownFrame: "rgb(58, 167, 255)", //ローソク陰線枠
        },
        area: {
          ChartFill: "rgba(246, 246, 248, 1)",
          AreaFill: "rgba(255, 255, 255, 1)",
          AreaDraw: "rgba(0, 0, 0, 0.5)",
          Grid: "rgba(221, 221, 221, 0.25)",
          SubChartLabel: "rgb(7, 19, 57)",
          Label: "rgba(7, 19, 57)",
          CK_ScaleLine: "rgba(0, 0, 0, 0.2)",
          CrossCursolLine: "rgba(63, 135, 237, 1)",
          CrossCursolLblDraw: "rgba(255, 255, 255, 1)",
          CrossCursolLblFill: "rgba(63, 135, 237, 1)",
        },
        compChart: {
          subBrand1: "rgb(0, 204, 255)",
          subBrand2: "rgb(0, 204, 0)",
        },
      },
      toolColor: {
        trendLine: {
          TrendLine: "rgba(7, 19, 57, 1);1",
          CK_HANDLINGDRAINGITEM: "rgba(63, 224, 85, 1)",
        },
        loupe: {
          CK_LOUPEFRAME: "rgba(0, 0, 0, 0.2)",
        },
        control: {
          CK_INNERAREAHANDLE: "rgb(7, 19, 57)",
        },
        PandF: {
          PAndF_Down: "rgba(60, 120, 255)",
          PAndF_Up: "rgba(241, 8, 90)",
        },
        Fibo: {
          FiboReTracement: "rgb(255, 153, 0);1",
          FiboExpansion: "rgb(0, 204, 0);1",
          FiboTimeZone: "rgb(0, 51, 255);1",
          FiboFan: "rgb(255, 102, 0);1",
          FiboArc: "rgb(255, 51, 255);1",
        },
        Gann: {
          GannFan: "rgb(238, 0, 119);1",
          GannGrid: "rgb(238, 0, 119);1",
        },
        Mado: {
          MadoBackGroundUp: "rgba(255, 0, 0, 0.4)",
          MadoBackGroundDown: "rgba(0, 51, 255, 0.4)",
          MadoValue: "rgb(0, 0, 0)",
        },
      },
    }
    this.TechColorWhiteSetting = {
      addon: {
        AverageN: {
          Ma1: "rgb(255, 204, 0);1",
          Ma2: "rgb(255, 102, 0);1",
          Ma3: "rgb(0, 204, 255);1",
          Ma4: "rgb(255, 51, 255);1",
          Ma5: "rgb(0, 204, 0);1",
        },
        Ichimoku: {
          KijunLine: "rgb(255, 102, 0);1",
          TenkanLine: "rgb(0, 204, 255);1",
          PrecedLine1: "rgb(255, 102, 153)",
          PrecedLine2: "rgb(102, 153, 255)",
          DelayLine: "rgb(255, 204, 0);1",
          Kumo: "rgba(255, 102, 153, 0.5)",
          Kumo2: "rgba(102, 153, 255, 0.5)",
        },
        Envelope: {
          EnvSigma1: "rgb(204, 153, 255);1",
          EnvSigma2: "rgb(204, 102, 255);1",
          EnvSigma3: "rgb(153, 0, 255);1",
          EnvSigma1m: "rgb(204, 153, 255);1",
          EnvSigma2m: "rgb(204, 102, 255);1",
          EnvSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        KSBolinger: {
          BolSigma1: "rgb(204, 153, 255);1",
          BolSigma2: "rgb(204, 102, 255);1",
          BolSigma3: "rgb(153, 0, 255);1",
          BolSigma1m: "rgb(204, 153, 255);1",
          BolSigma2m: "rgb(204, 102, 255);1",
          BolSigma3m: "rgb(153, 0, 255);1",
          Sma: "rgb(255, 204, 0);1",
        },
        // Parabolic: {
        //   Parabolic: "rgb(250, 223, 86)",
        // },
        ParabolicDiv: {
          CircleBuy: "rgb(255, 51, 102)",
          CircleSell: "rgb(51, 153, 255)",
        },
        HLBand: {
          Center: "rgb(0, 204, 0);1",
          HLine: "rgb(255, 51, 102);1",
          LLine: "rgb(255, 51, 102);1",
        },
        ATRChannel: {
          ATRChannelSigma1: "rgb(204, 153, 255);1",
          ATRChannelSigma2: "rgb(204, 102, 255);1",
          ATRChannelSigma3: "rgb(153, 0, 255);1",
          ATRChannelSigma1m: "rgb(204, 153, 255);1",
          ATRChannelSigma2m: "rgb(204, 102, 255);1",
          ATRChannelSigma3m: "rgb(153, 0, 255);1",
          Lma: "rgb(255, 204, 0);1",
        },
        EMA: {
          Short: "rgb(255, 102, 0);1",
          Middle: "rgb(0, 204, 0);1",
          Long: "rgb(0, 204, 255);1",
        },
        Kaiki: {
          KaikiSigma1: "rgb(204, 153, 255);1",
          KaikiSigma2: "rgb(204, 102, 255);1",
          KaikiSigma3: "rgb(153, 0, 255);1",
          KaikiSigma1m: "rgb(204, 153, 255);1",
          KaikiSigma2m: "rgb(204, 102, 255);1",
          KaikiSigma3m: "rgb(153, 0, 255);1",
          Kaiki: "rgb(255, 204, 0);1",
        },
        Vwap: {
          Vwap: "rgb(255, 102, 0);1",
        },
        tenkan: {
          //転換点
          Tenkan_Label: "rgb(7, 19, 57)",
          Tenkan_Draw: "rgba(36, 24, 24, 1)",
          Tenkan_Fill: "rgba(51, 51, 77, 0.5)",
        },
        CycleAna: {
          CycleHigh: "rgb(255, 0, 255)", // 日柄分析(上げ)
          CycleLow: "rgb(0, 255, 255)", // 日柄分析(下げ)
          CycleHighFont: "rgb(0, 0, 0)", // 日柄分析(上げ値)
          CycleLowFont: "rgb(0, 0, 0)", // 日柄分析(下げ値)
        },
        PriceVolume: {
          PriceVolume: "rgba(51, 102, 255, 0.5)", // 価格帯別出来高(グラフ）
          PvMaxVolume: "rgba(255, 0, 51, 0.5)", // 価格帯別出来高(最大グラフ）
          PvMaxNum: "rgba(0, 0, 0, 1)", // 価格帯別出来高(最大値）
          PvMaxNumBack: "rgba(255, 0, 51, 0.6)", // 価格帯別出来高(背景）
        },
      },
      sub: {
        RSI: {
          RSI: "rgb(255, 0, 157);1",
        },
        StocastKD: {
          PercentK: "rgb(45, 219, 49);1",
          PercentD: "rgb(45, 156, 219);1",
        },
        StocastDS: {
          PercentD: "rgb(45, 156, 219);1",
          SPercentD: "rgb(45, 217, 219);1",
        },
        PercentR: {
          PercentR: "rgb(255, 106, 0);1",
        },
        MACD: {
          MACD: "rgb(255, 0, 157);1",
          Signal: "rgb(0, 187, 255);1",
          OSCI: "rgb(255, 170, 85);1",
        },
        RCI3: {
          RCI1: "rgb(149, 0, 255);1",
          RCI2: "rgb(0, 204, 0);1",
          RCI3: "rgb(45, 217, 219);1",
        },
        CCI: {
          CCI: "rgb(255, 106, 0);1",
        },
        PsyCologic: {
          PsyCologic: "rgb(219, 45, 143);1",
        },
        ROC2: {
          ROC1: "rgb(255, 0, 157);1",
          ROC2: "rgb(0, 204, 0);1",
          Signal: "rgb(0, 187, 255);1",
        },
        ATR: {
          ATR: "rgb(0, 204, 0);1",
        },
        MomentumS: {
          Momentum: "rgb(219, 45, 143);1",
          Signal: "rgb(0, 187, 255);1",
        },
        DMImod: {
          "+DI": "rgb(255, 0, 153);1",
          "-DI": "rgb(0, 204, 255);1",
          ADX1: "rgb(153, 0, 255);1",
          ADXR1: "rgb(0, 204, 0);1",
          ADX2: "rgb(255, 102, 0);1",
          ADXR2: "rgb(255, 204, 0);1",
        },
        AroonIndi: {
          AroonUp: "rgb(255, 0, 157);1",
          AroonDown: "rgb(0, 187, 255);1",
        },
        AroonOsci: {
          AroonOsci: "rgb(255, 106, 0);1",
        },
        Kairi3: {
          Short: "rgb(219, 45, 143);1",
          Middle: "rgb(45, 219, 49);1",
          Long: "rgb(45, 156, 219);1",
        },
        Volume: {
          Today: "rgb(0, 187, 255);1",
          Volume: "rgb(201, 45, 219);1", // c92ddb(201,45,219)
          Short: "rgb(219, 45, 143);1", //b2d8f (219,45,143)
          Middle: "rgb(45, 219, 49);1", //2ddb31 (45,219,49)
          Long: "rgb(45, 156, 219);1", //2d9cdb  (45,156,219)
        },
        SinyouZan: {
          MarginBuying: "rgb(255, 34, 34);1",
          MarginSelling: "rgb(30, 100, 255);1",
        },
        // 標準偏差ボラティリティ
        StandardDeviation: {
          StandardDeviation: "rgb(242, 65, 157);1",
        },
        // 強弱レシオ
        HinoharaRatio: {
          RatioA: "rgb(242, 65, 157);1",
          RatioB: "rgb(62, 244, 32);1",
        },
        // 対比チャート用スプレッド
        Spread: {
          Spread1: "rgb(0, 255, 255);1",
          Spread2: "rgb(0, 255, 0);1",
        },
      },
    }
  }
}

export class TechSetting {
  TechnicalSettings: object
  constructor() {
    this.TechnicalSettings = {
      addon: {
        AverageN: {
          _Def: {
            AverageN_1: {
              default: 5,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AverageN_2: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AverageN_3: {
              default: 50,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AverageN_4: {
              default: 75,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AverageN_5: {
              default: 100,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        Ichimoku: {
          _Def: {
            Tenkan_Value: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Kijyun_Value: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Span_Value: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        Envelope: {
          _Def: {
            // "Envelope_Ma": "2",
            Envelope_Ma: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Envelope_1: {
              default: 2.5,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Envelope_2: {
              default: 5.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Envelope_3: {
              default: 7.5,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
          },
        },
        Bolinger: {
          _Def: {
            BolingerMa: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },

            Bolinger_1: {
              default: 1,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Bolinger_2: {
              default: 2,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Bolinger_3: {
              default: 3,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
          },
        },
        KSBolinger: {
          _Def: {
            BolingerMa: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },

            Bolinger_1: {
              default: 1,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Bolinger_2: {
              default: 2,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Bolinger_3: {
              default: 3,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
          },
        },
        Parabolic: {
          _Def: {
            Parabolic_Step: {
              default: 0.02,
              min: 0.01,
              max: 1,
              step: 0.01,
              precision: 2,
            },
            Parabolic_Max: {
              default: 0.2,
              min: 0.1,
              max: 1,
              step: 0.1,
              precision: 1,
            },
          },
        },
        ParabolicDiv: {
          _Def: {
            Parabolic_AF: {
              default: 0.02,
              min: 0.01,
              max: 1,
              step: 0.01,
              precision: 2,
            },
            Parabolic_Step: {
              default: 0.02,
              min: 0.01,
              max: 1,
              step: 0.01,
              precision: 2,
            },
            Parabolic_Max: {
              default: 0.2,
              min: 0.1,
              max: 1,
              step: 0.1,
              precision: 1,
            },
          },
        },
        HLBand: {
          _Def: {
            HLBand_highPeriod: {
              default: 20,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            HLBand_lowPeriod: {
              default: 20,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        ATRChannel: {
          _Def: {
            // "Envelope_Ma": "2",
            ATRChannel_Lma: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            ATRChannel_Atr: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },

            ATRChannel_1: {
              default: 1.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            ATRChannel_2: {
              default: 2.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            ATRChannel_3: {
              default: 3.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
          },
        },
        EMA: {
          _Def: {
            EMA_1: {
              default: 12,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            EMA_2: {
              default: 20,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            EMA_3: {
              default: 50,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Long_Vis: { type: "boolean", default: false },
            Middle_Vis: { type: "boolean", default: true },
            Short_Vis: { type: "boolean", default: true },
          },
        },
        Kaiki: {
          _Def: {
            Kikan: {
              default: 75,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            FutureSpan: {
              default: 0,
              min: 1,
              max: 100,
              step: 1,
              precision: 0,
            },
            Kaiki_1: {
              default: 1.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Kaiki_2: {
              default: 2.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
            Kaiki_3: {
              default: 3.0,
              min: 0.1,
              max: 100,
              step: 0.1,
              precision: 1,
            },
          },
        },
        // Vwapは制御パラメータあなし
        Vwap: {
          _Def: {},
        },
      },
      sub: {
        RSI: {
          _Def: {
            RSI_Period: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            RSI_Scale1: {
              default: 20,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            RSI_Scale2: {
              default: 80,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            RSI_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        StocastKD: {
          _Def: {
            Stocast_K: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Stocast_D: {
              default: 3,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Stocast_Scale1: {
              default: 30,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            Stocast_Scale2: {
              default: 70,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            Stocast_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        StocastDS: {
          _Def: {
            Stocast_DS_K: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Stocast_DS_D: {
              default: 3,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Stocast_DS_S: {
              default: 3,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Stocast_Scale1: {
              default: 30,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            Stocast_Scale2: {
              default: 70,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            Stocast_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        PercentR: {
          _Def: {
            PercentR_Period: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            PercentR_Scale1: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            PercentR_Scale2: {
              default: 30,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            PercentR_Scale3: {
              default: 70,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        MACD: {
          _Def: {
            MACD_S: {
              default: 12,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            MACD_L: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            MACD_signal: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        RCI3: {
          _Def: {
            RCI_Period1: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            RCI_Period2: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            RCI_Period3: {
              default: 52,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            RCI_Scale1: {
              default: 0,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            RCI_Scale2: {
              default: 70,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            RCI_Scale3: {
              default: -70,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        CCI: {
          _Def: {
            CCI_Period: {
              default: 15,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            CCI_Scale1: {
              default: 0,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            CCI_Scale2: {
              default: 70,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            CCI_Scale3: {
              default: -70,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        PsyCologic: {
          _Def: {
            PsyCologic_Period: {
              default: 12,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            PsyCologic_Scale1: {
              default: 25,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            PsyCologic_Scale2: {
              default: 75,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            PsyCologic_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        // ROC３本
        ROC2: {
          _Def: {
            ROC_Period1: {
              default: 12,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            ROC_Period2: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            ROC_Period3: {
              default: 50,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            ROC_Scale1: {
              default: 0,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
            ROC_Scale2: {
              default: 5,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
            ROC_Scale3: {
              default: -5,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
          },
        },
        ATR: {
          _Def: {
            ATR_Period: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            ATR_Scale1: {
              default: 0,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
            ATR_Scale2: {
              default: 5,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
            ATR_Scale3: {
              default: -5,
              min: -10,
              max: 10,
              step: 1,
              precision: 0,
            },
          },
        },
        MomentumS: {
          _Def: {
            Momentum_Period1: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Momentum_SKikan: {
              default: 10,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        DMI: {
          _Def: {
            DMI_dmi: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adx: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adxr: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        DMImod: {
          _Def: {
            DMI_dmi: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adx1: {
              default: 9,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adxr1: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adx2: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            DMI_Adxr2: {
              default: 14,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        AroonIndi: {
          _Def: {
            AroonIndi_UpPeriod: {
              default: 10,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AroonIndi_DownPeriod: {
              default: 10,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AroonIndi_Scale1: {
              default: 30,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            AroonIndi_Scale2: {
              default: 70,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            AroonIndi_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        AroonOsci: {
          _Def: {
            AroonOsci_UpPeriod: {
              default: 10,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AroonOsci_DownPeriod: {
              default: 10,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            AroonOsci_Scale1: {
              default: 30,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            AroonOsci_Scale2: {
              default: 70,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
            AroonOsci_Scale3: {
              default: 50,
              min: 0,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        Kairi3: {
          _Def: {
            Kairi3_1: {
              default: 5,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Kairi3_2: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Kairi3_3: {
              default: 75,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Kairi3_Scale1: {
              default: 0,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            Kairi3_Scale2: {
              default: 10,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
            Kairi3_Scale3: {
              default: -10,
              min: -100,
              max: 100,
              step: 1,
              precision: 0,
            },
          },
        },
        Volume: {
          _Def: {
            Volume_Short: {
              default: 5,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Volume_Middle: {
              default: 25,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
            Volume_Long: {
              default: 75,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        // 信用残は制御パラメータなし（売残し・買残しあるがデフォルトで表示させる）
        SinyouZan: {
          _Def: {
            MarginBuying: true,
            MarginSelling: true,
          },
        },
        // 標準偏差ボラティリティ
        StandardDeviation: {
          _Def: {
            STANDARD_DEVIATION_Period: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
        },
        // 強弱レシオ
        HinoharaRatio: {
          _Def: {
            HinoharaRatio_Period: {
              default: 26,
              min: 1,
              max: 400,
              step: 1,
              precision: 0,
            },
          },
          // 対比チャート用スプレッド
          Spread: {
            _Def: {
              visible: true,
            },
          },
        },
      },
    }
    this.customTechnicalOption("addon", "AverageN", {
      [TERM[7].key]: {
        AverageN_1: 3,
        AverageN_2: 6,
        AverageN_3: 9,
        AverageN_4: 12,
        AverageN_5: 24,
      },
      [TERM[8].key]: {
        AverageN_1: 5,
        AverageN_2: 25,
        AverageN_3: 50,
        AverageN_4: 75,
        AverageN_5: 100,
      },
      [TERM[9].key]: {
        AverageN_1: 13,
        AverageN_2: 26,
        AverageN_3: 39,
        AverageN_4: 52,
        AverageN_5: 65,
      },
    })
    this.customTechnicalOption("addon", "Bolinger", {
      [TERM[7].key]: { BolingerMa: 6 },
      [TERM[8].key]: { BolingerMa: 25 },
      [TERM[9].key]: { BolingerMa: 26 },
    })
    this.customTechnicalOption("addon", "KSBolinger", {
      [TERM[7].key]: { BolingerMa: 6 },
      [TERM[8].key]: { BolingerMa: 25 },
      [TERM[9].key]: { BolingerMa: 26 },
    })
    this.customTechnicalOption("addon", "Envelope", {
      [TERM[7].key]: { Envelope_Ma: 6 },
      [TERM[8].key]: { Envelope_Ma: 25 },
      [TERM[9].key]: { Envelope_Ma: 26 },
    })
    this.customTechnicalOption("addon", "ATRChannel", {
      [TERM[6].key]: { ATRChannel_Lma: 20, ATRChannel_Atr: 20 },
      [TERM[10].key]: { ATRChannel_Lma: 20, ATRChannel_Atr: 20 },
    })
    this.customTechnicalOption("addon", "EMA", {
      [TERM[6].key]: { EMA_1: 5, EMA_2: 12, EMA_3: 20 },
      [TERM[9].key]: { EMA_1: 13, EMA_2: 26, EMA_3: 52 },
      [TERM[10].key]: { EMA_1: 6, EMA_2: 12, EMA_3: 24 },
    })
    this.customTechnicalOption("addon", "Kaiki", {
      [TERM[6].key]: { Kikan: 25 },
      [TERM[10].key]: { Kikan: 25 },
    })

    this.customTechnicalOption("addon", "Envelope", {
      [TERM[8].key]: {
        Envelope_Ma: 25,
        Envelope_1: 2.5,
        Envelope_2: 5,
        Envelope_3: 7.5,
      },
      [TERM[9].key]: {
        Envelope_Ma: 26,
        Envelope_1: 10,
        Envelope_2: 20,
        Envelope_3: 30,
      },
      [TERM[10].key]: {
        Envelope_Ma: 12,
        Envelope_1: 25,
        Envelope_2: 50,
        Envelope_3: 75,
      },
    })
    this.customTechnicalOption("sub", "Volume", {
      [TERM[8].key]: { Volume_Short: 5, Volume_Middle: 25, Volume_Long: 75 },
      [TERM[9].key]: { Volume_Short: 13, Volume_Middle: 26, Volume_Long: 39 },
    })
    this.customTechnicalOption("sub", "Kairi3", {
      [TERM[8].key]: { Kairi3_1: 5, Kairi3_2: 25, Kairi3_3: 75 },
      [TERM[9].key]: {
        Kairi3_1: 13,
        Kairi3_2: 26,
        Kairi3_3: 39,
      },
    })
  }
  customTechnicalOption = (type: string, chart: string, value: object) => {
    forEach(value, (target, term) => {
      forEach(target, (items, key) =>
        merge(
          this.TechnicalSettings,
          set({}, [type, chart, "_Def", key, term], items)
        )
      )
    })
  }
}

const _TechnicalSettings = new TechSetting()
const _colorSettings = new ChartColor()

const Chart: chartObj = {
  defaultChartTechnicalSettings: _TechnicalSettings.TechnicalSettings,
  defaultChartColorSettings: _colorSettings.ColorSettings,
  defaultChartColorWhiteSettings: _colorSettings.ColorWhiteSettings,
  ChartSessions: {},
}

export class PRICE_VOLUME_PARAM {
  param: object
  constructor() {
    this.param = {
      DispWidthRatio: 0.95,
      MaxDisp: true,
      Ratio: 2,
    }
  }
}

export class CYCLE_ANALYSIS_TYPE {
  param: Array<{
    id: number
    displayTitle: string
    key: string
  }>
  constructor() {
    this.param = [
      {
        id: 0,
        displayTitle: "全日柄",
        key: "AllDisp",
      },
      {
        id: 1,
        displayTitle: "高値日柄",
        key: "HighDisp",
      },
      {
        id: 2,
        displayTitle: "安値日柄",
        key: "LowDisp",
      },
    ]
  }
}

export const CycleAnaTypesValue = new CYCLE_ANALYSIS_TYPE().param

export const EX_SECURITY_TYPE = 12000
export const EX_EXCHANGE = 400
export const CHART_SCROLL_HEIGHT = 20 // スクロールバー高さ
export const LIMIT_RENDER_COUNT = 300
export const LIMIT_RENDER_COUNT_MINI = 60
export const TENKANTEN = 10
export const MINUTE_TERM_ID = [0, 1, 2, 3, 4, 5, 6, 7]
export const MODAL_CANVAS_ID = "sp-modal"
export const MODAL_INDICATOR_CANVAS_ID = "sp-modal-indicator"
export const CHART_ASHI_MIN = 26
export const MAX_SCROLL_SPAN = 31

export default Chart
